<template>
  <div id="boardChart" class="load-profile-details">
    <div class="warning-area">
      <div
        class="alert alert-warning alert-dismissible fade show"
        role="alert"
        v-for="alert in activePeriodAlerts"
        :key="alert.id"
      >
        <strong>Überschneidende Zeiträume!</strong>
        <span> - </span>
        <span class="alert-message">
          {{ alert.message }}
        </span>

        <span class="alert-close">
          <b-icon icon="x-lg" @click="dismissAlert(alert.id)"></b-icon>
        </span>
      </div>
    </div>
    <modal-share
      class="modal-window"
      v-show="isModalVisible"
      @close="closeModal"
    />
    <updates
      v-if="isShowupdate"
      :updates="activeUpdates"
      @close="closeTimeSerierLogs"
      dbType="loadprofile"
      ref="loadProfileLogModalRef"
    />
    <div class="chart-content">
      <LoadingSpinner v-show="isLoading" />
      <div class="chart-wrap">
        <div class="chart">
          <StockChart
            :ref="isAdmin ? 'Chart' : null"
            :seriesDetails="[timeseries]"
            :xAxisPlotBands="getPlotBands"
            :enable-tooltip="true"
            :enable-x-axies-labels="true"
            :enable-y-axies-labels="true"
            :redrawChart="redrawChart"
            :enable-legend="isLoadProfileTypeCustom ? true : false"
            :isDragUnableOnPoints="isLoadProfileTypeCustom ? false : true"
            :calculateMetaData="calculateMetaData"
            :setAndCreateLogObject="setAndCreateLogObject"
            :addNewSeries="addNewSeries"
            @setOperationOverlay="toggleOperationOverlay"
            @setSelectionRange="handleChartSelectionChange"
            @setMinimumChartValue="handleChartMinimumValue"
            @setMaximumChartValue="handleChartMaximumValue"
            @setDragDataPoints="handleDragDataPointsChange"
          />
        </div>
      </div>
    </div>

    <div class="side-panel fancy-scroll">
      <div
        class="side-bar-options wrapper"
        :class="{ 'modal-open': isChangeUnitModalOpen }"
      >
        <ul class="side-bar-options">
          <li
            v-b-tooltip.hover
            title="Änderungsverlauf"
            @click="openTimeSerierLogs"
          >
            <span class="clock-icon"><i class="fa fa-clock"></i></span>
          </li>
          <li
            v-b-tooltip.hover
            title="Tags verwalten"
            class="tag-manager-trigger"
            @click="openTagManager"
          >
            <span class="clock-icon"><i class="fa fa-tag"></i></span>
            <span
              class="tag-counter"
              v-if="timeseries.tags && timeseries.tags.length"
            >
              {{ timeseries.tags.length }}
            </span>
          </li>
          <li
            class="download"
            @click="exportFile()"
            v-b-tooltip.hover
            v-if="!isLoadProfileTypeCustom"
            title="Herunterladen"
          >
            <a
              class="download-excel"
              :class="{ 'button--loading': isDownloading }"
            >
              <span class="accessibility">Download xls</span>
            </a>
          </li>
          <li>
            <generalDropdown :isCaretVisible="false">
              <template v-slot:iconContainer>
                <span class="tool-icon more-icon">
                  <img src="../assets/img/more-icon.svg" alt="more" />
                </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="action in actionList"
                  :key="action.id"
                  @click="runAction(action)"
                >
                  {{ action.name }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="userHasPermissionToAddFlow"
                  @click="createNewAction()"
                >
                  <i class="far fa-plus-square me-2"></i>Neue Aktion hinzufügen
                </b-dropdown-item>
              </template>
            </generalDropdown>
          </li>
          <!--<li class="share" v-on:click="showModal()">
        <a>
          <span class="accessibility">Share Link</span>
        </a>
      </li>-->
          <!--<li class="sidebar-toggle">
        <a>
          <span class="accessibility">Toggle Sidebar</span>
        </a>
      </li>-->
          <li
            class="close-modal"
            @click="close()"
            v-b-tooltip.hover
            title="Schliessen"
          >
            <a>
              <span class="accessibility">Close board item</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="side-panel-inner">
        <div class="load-details">
          <input
            :disabled="!isMetaDataEditable"
            v-model="timeseries.name"
            placeholder="Bezeichnung eingeben..."
            class="rename analysis-title"
            @blur="checkMetaDataChange('name')"
          />
          <!--
          <input
            v-model="timeseries.supplyPoint.name"
            placeholder="Kundenname eingeben..."
            class="rename title"
            v-if="false"
          />
          -->
          <div class="malo-id">
            <span v-show="timeseries.supplyPoint.maLoID"> MaLo-ID:</span>
            <input
              :disabled="!isMetaDataEditable"
              v-model="timeseries.supplyPoint.maLoID"
              placeholder="MaLo-ID eingeben..."
              class="rename title"
              @blur="checkMetaDataChange('maLoID')"
            />
          </div>
          <div class="tags-section">
            <div class="tags" v-if="timeseriesTagObjects.length > 0">
              <span
                v-for="(tag, index) in timeseriesTagObjects"
                :key="`timeseries-tag-${tag.name}-${index}`"
                class="badge badge-secondary tag-preview-item"
                :style="{ 'background-color': tag.color || '#4f46e5' }"
              >
                <span class="tag-label">{{ tag.name }}</span>
              </span>
            </div>
            <div v-else class="tags-empty">Keine Tags vorhanden</div>
          </div>
          <!--
          <input
            v-model="timeseries.supplyPoint.address"
            placeholder="Adresse eingeben..."
            class="rename subtitle"
            v-if="false"
          />-->

          <div class="load-statistics">
            <div class="info-item">
              <div class="value small" @click="consoleLogMetadata()">
                Anfang:
                {{ getFormatedDateInCET(timeseries.start) }}
                <br />
              </div>
            </div>
            <div class="info-item">
              <div class="value small">
                Ende:
                {{ getFormatedDateInCET(timeseries.end) }}
                <br />
              </div>
            </div>
            <div class="info-item">
              <div class="value small">
                Datenpunkte:
                {{
                  timeseries.hasOwnProperty('dataPointCount')
                    ? timeseries.dataPointCount
                    : 'Nicht vorhanden'
                }}
              </div>
            </div>
            <div class="info-item">
              <div class="value small">
                <span class="title-tag">Einheit </span>:

                <generalDropdown
                  :disabled="
                    !isMetaDataEditable ||
                    isLoadProfileTypeCustom ||
                    database.add_only
                  "
                  className="filter-dropdown"
                >
                  <template v-slot:selectFilter>
                    <!-- <span class="line-clamp">{{ activeUnit }} </span> -->
                    <span class="line-clamp">{{ timeseries.unit }} </span>
                  </template>
                  <template v-slot:optionData>
                    <b-dropdown-item
                      v-for="unit in unitList"
                      :key="unit"
                      @click="openChangeUnit($event, unit)"
                    >
                      {{ unit }}
                    </b-dropdown-item>
                  </template>
                </generalDropdown>
                <changeUnitModal
                  v-if="isChangeUnitModalOpen"
                  :isLoading="isChangetUnitModalLoading"
                  @reInterpretUnit="addUnitWithoutConvert"
                  @convertLoadUnit="convertLoadUnit"
                  @closeUnitModal="closeUnitModal"
                ></changeUnitModal>
              </div>
            </div>
            <div class="info-item">
              <div class="value small">
                <span class="title-tag">Frequenz</span>:
                <generalDropdown
                  :disabled="
                    isFreqEditable === false ||
                    isLoadProfileTypeCustom ||
                    database.add_only
                  "
                >
                  <template v-slot:selectFilter>
                    <span class="line-clamp frequency"
                      >{{ activeFrequency }}
                    </span>
                  </template>
                  <template v-slot:optionData>
                    <b-dropdown-item
                      :key="frequency.label"
                      v-for="frequency in activeFrequencies"
                      @click="convertLoadFreq(frequency.value)"
                    >
                      {{ frequency.label }}
                    </b-dropdown-item>
                  </template>
                </generalDropdown>
                <changeUnitModal
                  v-if="isChangeUnitModalOpen"
                  :isLoading="isChangetUnitModalLoading"
                  @reInterpretUnit="addUnitWithoutConvert"
                  @convertLoad="convertLoadUnit"
                  @closeUnitModal="closeUnitModal"
                ></changeUnitModal>
              </div>
            </div>
            <div
              class="info-item desription"
              placeholder="Type Something"
              v-if="
                (isMetaDataEditable || showDescription) &&
                !isLoadProfileTypeCustom
              "
            >
              <div class="value small">
                <!-- <span> Beschreibung : </span> -->
                <!-- <textarea
                  placeholder="Beschreibung eingeben..."
                  rows="3"
                  type="textarea"
                  name="description"
                  id="description"
                  :disabled="!isMetaDataEditable"
                  v-model="timeseries.description"
                  @blur="checkMetaDataChange('description')"
                  @input="onDescriptionInput($event.target)"
                /> -->
                <div
                  :contenteditable="isMetaDataEditable"
                  @input="onDescriptionInput"
                  @blur="checkMetaDataChange('description')"
                  name="description"
                  id="description"
                  class="text-area-div"
                  placeholder="Beschreibung eingeben..."
                  v-html="timeseries.description ? timeseries.description : ''"
                />
              </div>
            </div>
            <div v-if="!isLoadProfileTypeCustom" class="row">
              <div class="col info-row-items">
                <div class="info-item">
                  <div class="label">Max:</div>
                  <div class="value">
                    <span class="big-font">{{
                      formatNumber(timeseries.max, '')
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="col info-row-items">
                <div class="info-item">
                  <div class="label">Min:</div>
                  <div class="value">
                    <span class="big-font">{{
                      formatNumber(timeseries.min, '')
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="col info-row-items">
                <div class="info-item">
                  <div class="label">Avg:</div>
                  <div class="value">
                    <span class="big-font">{{
                      formatNumber(timeseries.avg, '')
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isLoadProfileTypeCustom" class="info-item">
              <div class="label">Summe:</div>
              <div class="value">
                <span class="big-font">{{
                  formatNumber(timeseries.sum, '')
                }}</span>
              </div>
              <div class="label">Gesamtmenge:</div>
              <div class="value">
                <span class="big-font">{{
                  formatNumber(
                    timeseries.quantity.value,
                    timeseries.quantity.unit
                  )
                }}</span>
              </div>
              <div class="label">Benutzungsstunden:</div>
              <div class="value">
                <!-- TODO: remove the selectedSeriesIndex == 0 when ts-calc-API is fixed -->
                <span
                  class="big-font"
                  v-b-tooltip.hover
                  :title="
                    timeseries.hasOwnProperty('usageHoursPercent') &&
                    timeseries.usageHoursPercent != null
                      ? displayFormat(timeseries.usageHoursPercent) + '%'
                      : null
                  "
                  >{{
                    timeseries.hasOwnProperty('usageHours') &&
                    timeseries.usageHoursPercent != null
                      ? displayFormat(timeseries.usageHours)
                      : 'Nicht vorhanden'
                  }}</span
                >
              </div>

              <div id="more-operations" class="more-operations">
                <div class="operations-toggle">
                  <span
                    v-if="!isMoreOperationsVisible"
                    class="clickable"
                    @click="showMoreOperations"
                    ><u>Zeitreihe bearbeiten</u></span
                  >
                  <span v-else class="clickable" @click="hideMoreOperations"
                    ><u>Schliessen</u></span
                  >
                </div>
                <div v-show="isMoreOperationsVisible" class="operations">
                  <div
                    :class="{
                      'chart-operation-block-overlay':
                        isOperationOverlayVisible,
                    }"
                  >
                    <div class="row">
                      <div class="col-7 mx-2">
                        <label for="operation-value"
                          >Zahl (Summand, Subtrahend, Faktor oder
                          Divisor):</label
                        ><br />
                        <div class="form-modal">
                          <div class="form-input">
                            <input
                              id="operation-value"
                              type="number"
                              step="any"
                              v-model="operationParams.value"
                              @input="onInputChangeOfOperationValue()"
                            />
                          </div>
                          <div class="units">
                            <span
                              v-if="operationParams.calculationUnit === 'kWh'"
                              >kWh</span
                            >
                            <span
                              v-if="
                                operationParams.calculationUnit === 'percentage'
                              "
                              >%</span
                            >
                            <span
                              v-if="
                                operationParams.calculationUnit ===
                                'kWh_percentage'
                              "
                              >% kWh</span
                            >
                          </div>
                          <div class="mt-2">
                            <div
                              class="operation-method btn calculation-left-btn"
                              :class="{
                                selected:
                                  operationParams.calculationUnit ===
                                    'percentage' ||
                                  operationParams.calculationUnit ===
                                    'kWh_percentage',
                              }"
                              style="line-height: 33px; font-size: 11px"
                              @click="setCalculationUnit('percentage')"
                            >
                              <i class="fa fa-percent"></i>
                            </div>
                            <div
                              class="operation-method btn"
                              style="line-height: 33px; font-size: 11px"
                              :class="{
                                selected:
                                  operationParams.calculationUnit === 'kWh' ||
                                  operationParams.calculationUnit ===
                                    'kWh_percentage',
                              }"
                              v-if="timeseries.unit"
                              @click="setCalculationUnit('kWh')"
                            >
                              kWh
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="operation-methods col calculation-btn">
                        <div
                          class="operation-method btn calculation-left-btn"
                          @click="calculateEach('add')"
                        >
                          <i class="fa fa-plus"></i>
                        </div>
                        <div
                          class="operation-method btn"
                          @click="calculateEach('multiply')"
                          :class="{
                            'grey-out':
                              operationParams.calculationUnit === 'kWh' ||
                              operationParams.calculationUnit ===
                                'kWh_percentage',
                          }"
                        >
                          <i class="fa fa-times"></i>
                        </div>
                        <div
                          class="operation-method btn calculation-left-btn"
                          @click="calculateEach('subtract')"
                        >
                          <i class="fa fa-minus"></i>
                        </div>
                        <div
                          class="operation-method btn"
                          :class="{
                            'grey-out':
                              operationParams.calculationUnit === 'kWh' ||
                              operationParams.calculationUnit ===
                                'kWh_percentage',
                          }"
                          @click="calculateEach('divide')"
                        >
                          <i class="fa fa-divide"></i>
                        </div>
                        <div
                          class="operation-method btn calculation-left-btn"
                          :class="{ 'grey-out': isFirstLoad }"
                          @click="switchSeriesDown() && !isFirstLoad"
                        >
                          <i class="fa fa-undo"></i>
                        </div>
                        <div
                          class="operation-method btn"
                          :class="{ 'grey-out': isLastLoad }"
                          @click="switchSeriesUp() && !isLastLoad"
                        >
                          <i class="fa fa-redo"></i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3 mx-2">
                      <div class="col">
                        <div v-if="timeseries.unit">
                          <label for="operation-value">Menge</label><br />
                          <div
                            class="set-quantity"
                            :class="{ refresh: isQuantityLoading }"
                          >
                            <input
                              type="number"
                              class="formatted-number"
                              v-model="totalQuantity"
                            />
                            <LoadingSpinner v-if="isQuantityLoading" />
                            <button @click="scaleQuantity">Übernehmen</button>
                            <div class="units">
                              <span>kWh</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row mt-3 mx-2">
                      <div class="col">
                        <span class="calculation-selection sub-title"
                          >Bearbeitung auf Bereich beschränken</span
                        >
                      </div>
                    </div>
                    <!-- Selection by Months -->
                    <div class="row mt-3 mx-2">
                      <div class="col ml-2">
                        <div class="checkbox-label">
                          <span>
                            <input
                              type="checkbox"
                              v-model="isLimitLoadEditToMonthInterval"
                              @click="resetMonthInterval()"
                            />
                          </span>
                          <label for="selection-label">Monate</label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mx-2"
                      v-show="isLimitLoadEditToMonthInterval"
                    >
                      <div class="col">
                        <div class="duration-button-wrapper">
                          <div
                            v-for="month in monthsInterval"
                            :key="month.id"
                            class="operation-method month btn"
                            :class="{ selected: month.selected }"
                            @click="toggleMonth(month)"
                          >
                            {{ month.text }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Selection by Quarters -->
                    <div class="row mt-3 mx-2">
                      <div class="col ml-2">
                        <div class="checkbox-label">
                          <span data-dz-checkbox>
                            <input
                              type="checkbox"
                              v-model="isLimitLoadEditToQuarterInterval"
                              @click="resetQuarterInterval()"
                            />
                          </span>
                          <label for="selection-label">Quartale</label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mx-2"
                      v-show="isLimitLoadEditToQuarterInterval"
                    >
                      <div class="col">
                        <div class="duration-button-wrapper">
                          <div
                            v-for="quarter in relevantQuarters"
                            :key="quarter.id"
                            class="operation-method quarter btn"
                            :class="{
                              selected: quarter.selected,
                            }"
                            @click="toggleQuarter(quarter)"
                          >
                            {{ quarter.text }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Selection by custom date range -->
                    <div class="row mt-3 mx-2">
                      <div class="col ml-2">
                        <div class="checkbox-label">
                          <span data-dz-checkbox>
                            <input
                              type="checkbox"
                              v-model="isLimitLoadEditToDateInterval"
                              @click="resetDateInterval(false)"
                            />
                          </span>
                          <label for="selection-label">Benutzerdefiniert</label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row chart-date-input-range mx-2"
                      v-show="isLimitLoadEditToDateInterval"
                    >
                      <div class="col">
                        <label for="operation-start">Start:</label><br />
                        <input
                          id="operation-start"
                          :min="getFormatedDate(timeseries.start)"
                          :max="getFormatedDate(timeseries.end)"
                          type="datetime-local"
                          v-model="operationParams.intervals.startDate"
                          @change="handleSelectionChange"
                        />
                      </div>
                      <div class="col">
                        <label for="operation-end">Ende:</label><br />
                        <input
                          id="operation-end"
                          type="datetime-local"
                          :min="getFormatedDate(timeseries.start)"
                          :max="getFormatedDate(timeseries.end)"
                          v-model="operationParams.intervals.endDate"
                          @change="handleSelectionChange"
                        />
                      </div>
                    </div>

                    <div
                      class="row mt-3 mx-2"
                      v-if="isLimitLoadEditToDateInterval"
                    >
                      <div class="col">
                        <div class="duration-button-wrapper">
                          <div
                            v-b-tooltip.hover
                            title="Zeitraum aus dem Diagramm in Start und Ende übernehmen"
                            class="operation-method sync btn"
                            @click="syncDateRange('chart')"
                          >
                            <img
                              :src="getImgUrl('./chart-to-settings.svg')"
                              alt=""
                            />
                          </div>
                          <div
                            v-b-tooltip.hover
                            title="Zeitraum aus Start und Ende ins Diagramm übertragen"
                            class="operation-method sync btn"
                            @click="syncDateRange('input')"
                          >
                            <img
                              :src="getImgUrl('./settings-to-chart.svg')"
                              alt=""
                            />
                          </div>
                        </div>
                        <div v-if="isSetSelectionDateRange">
                          <span class="clickable grey">
                            <u @click="resetDateInterval(false)"
                              >Auswahl zurücksetzen</u
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3 mx-2">
                      <div class="col">
                        <span class="calculation-selection sub-title"
                          >Bearbeitung auf Intervall beschränken</span
                        >
                      </div>
                    </div>
                    <!-- Day interval -->
                    <div class="row mt-3 mx-2">
                      <div class="col ml-2">
                        <div class="checkbox-label">
                          <span data-dz-checkbox>
                            <input
                              type="checkbox"
                              v-model="isLimitLoadEditToDayInterval"
                              @click="resetDayInterval()"
                            />
                          </span>
                          <label for="selection-label">Wochentage</label>
                        </div>
                      </div>
                    </div>
                    <div class="row mx-2" v-show="isLimitLoadEditToDayInterval">
                      <div class="col">
                        <div class="duration-button-wrapper">
                          <div
                            v-for="day in days"
                            :key="day.name"
                            class="operation-method day btn"
                            :class="{
                              clicked: day.selected,
                            }"
                            @click="toggleDay(day)"
                          >
                            {{ day.text }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Time interval -->
                    <div class="row mt-3 mx-2">
                      <div class="col ml-2">
                        <div class="checkbox-label">
                          <span data-dz-checkbox>
                            <input
                              type="checkbox"
                              v-model="isLimitLoadEditToTimeInterval"
                              @click="resetTimeInterval()"
                            />
                          </span>
                          <label for="selection-label">Zeitperiode</label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mx-2"
                      v-show="isLimitLoadEditToTimeInterval"
                    >
                      <div class="col3 ml-3">
                        <label for="operation-start">Start:</label><br />
                        <vue-timepicker
                          class="custom-time-picker"
                          manual-input
                          hide-dropdown
                          :minute-interval="15"
                          v-model="operationParams.intervals.startTime"
                          @change="handleSelectionChange"
                        ></vue-timepicker>
                      </div>
                      <div class="col3 ml-3">
                        <label for="operation-start">Ende:</label><br />
                        <vue-timepicker
                          class="custom-time-picker"
                          :minute-interval="15"
                          auto-scroll
                          manual-input
                          hide-dropdown
                          v-model="operationParams.intervals.endTime"
                          @change="handleSelectionChange"
                        ></vue-timepicker>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-2 mt-4">
                    <div class="col">
                      <a
                        v-if="timeseries.min < 0"
                        @click="deleteNegativeValues()"
                        ><u>Negative Werte löschen</u></a
                      >
                      <!--<button
                        class="operation-method btn remove-value"
                        @click="deleteNegativeValues()"
                      >Negative Werte Löschen</button>-->
                    </div>
                    <div class="col">
                      <button
                        class="button save"
                        @click="saveNewSeries()"
                        v-if="!isSaveSeriesDisabled"
                        :class="{ disabled: isAddOnly }"
                        :disabled="isAddOnly"
                      >
                        Speichern
                      </button>
                      <button
                        @click="saveNewSeries()"
                        v-show="isSaving"
                        class="button save saving"
                      >
                        <i class="fas fa-check"></i>
                      </button>
                    </div>
                  </div>

                  <!-- hidden -->
                  <label v-show="false" for="operation-blocks">Blöcke:</label
                  ><br />
                  <select
                    v-show="false"
                    v-model="operationParams.blocks"
                    required
                  >
                    <option v-for="b in blocks" :key="b">
                      {{ b }}
                    </option>
                  </select>
                  <!-- / hidden -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
              <div class="info-item">
                <div class="label">PFC-Preis:</div>
                <div class="value"><span class="big-font">3,5 </span>
                  <span class="small">Ct/kWh</span>
                </div> -->
      </div>
    </div>
    <LoadProfileTagManagerModal
      :visible="isTagManagerVisible"
      :tags="timeseriesTagObjects"
      :suggestions="databaseTagSuggestions"
      :canEdit="canEditTags"
      @close="closeTagManager"
      @change="onTagManagerChange"
    />
    <htmlViewer
      v-if="htmlViewerModal.isHtmlViewerVisible"
      @close="closeHtmlViewer"
      :myHtml="htmlViewerModal.myHtml"
    >
    </htmlViewer>
    <!-- action workflow vue based preview -->
    <GeneralModal
      class="vue-action-preview-modal"
      v-if="isRunActionLoadingModalVisible"
      @close="onCloseRunActionLoadingModal"
    >
      <div class="run-action-loading-center">
        <div class="progress-icon dark-color center"></div>
      </div>
    </GeneralModal>
    <GeneralModal
      class="vue-action-preview-modal"
      v-if="vueBasedProcessPreview.isVisible"
      @close="onCloseVueBasedPreview"
    >
      <ProcessPreview
        :executionUrl="vueBasedProcessPreview.executionUrl"
        :isActionFlow="true"
        :processID="vueBasedProcessPreview.flowId"
        :params="vueBasedProcessPreview.params"
      />
    </GeneralModal>
  </div>
</template>

<script>
//"modalBox.show"
import ModalShare from './modals/ModalShare.vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from '../store/store';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import changeUnitModal from './modals/changeUnitModal.vue';
import LoadingSpinner from '../components/widgets/LoadingSpinner.vue';
import Updates from './Updates.vue';
import moment from 'moment';
import StockChart from './charts/StockChart.vue';
import GeneralDropdown from './core/general-dropdown.vue';
import {
  timestampToCETConvertor,
  getCETTimeStampFromDate,
  convertDateToCETDate,
} from '../utils/helpers.js';
import { mapGetters } from 'vuex';
import { runFlowByID } from '../services/axios/flow-runner.api';
import htmlViewer from './modals/htmlViewer.vue';
import { getFlowLastId } from '../utils/helpers';
import { getLogs } from '../services/axios/data.api';
import { updateTableSchema } from '../services/userTable';

import GeneralModal from '@/components/modals/GeneralModal.vue';
import ProcessPreview from '@/components/Process/ProcessPreview.vue';
import { newWorkflowDefaultVersion } from '@/utils/constants/WorkFlowConstants.js';
import LoadProfileTagManagerModal from './LoadProfile/LoadProfileTagManagerModal.vue';

export default {
  name: 'LoadProfileDetails',
  data() {
    return {
      tsEndpoint: process.env.VUE_APP_TS_CALCULATION_API,
      redrawChart: false,
      downloadClick: false,
      count: 0,
      isDownloading: false,
      isToolTipVisible: false,
      isSaving: false,
      isMoreOperationsVisible: false,
      myTime: null,
      unitList: ['kWh', 'kW', 'MW', 'MWh'],
      frequencyList: [
        { label: 'Viertelstündlich', value: '15T' },
        { label: 'Stündlich', value: 'H' },
        { label: 'Täglich', value: 'D' },
      ],
      periodAlerts: [],
      seriesList: [
        {
          supplyPoint: {
            name: null,
            meloId: null,
            address: null,
          },
          name: '',
          description: '',
          unit: null,
          begin: null,
          end: null,
          sum: 0,
          avg: 0,
          min: 0,
          max: 0,
          type: null,
        },
      ],
      selectedSeriesIndex: 0,
      //date format options
      dateOptions: {
        hour12: false,
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        timeZone: 'CET',
      },
      isModalVisible: false,
      modalBox: {
        show: true,
        title: '',
        msg: '',
        btnCaption: '',
      },
      days: [
        { name: 'mon', text: 'Mo', value: 0, selected: false },
        { name: 'tue', text: 'Di', value: 1, selected: false },
        { name: 'wed', text: 'Mi', value: 2, selected: false },
        { name: 'thu', text: 'Do', value: 3, selected: false },
        { name: 'fri', text: 'Fr', value: 4, selected: false },
        { name: 'sat', text: 'Sa', value: 5, selected: false },
        { name: 'sun', text: 'So', value: 6, selected: false },
      ],
      monthsInterval: [],
      months: {
        January: 'Januar',
        February: 'Februar',
        March: 'März',
        April: 'April',
        May: 'Mai',
        June: 'Juni',
        July: 'Juli',
        August: 'August',
        September: 'September',
        October: 'Oktober',
        November: 'November',
        December: 'Dezember',
      },
      quarters: [],
      operationParams: {
        intervals: {
          startDate: null,
          endDate: null,
          startTime: { HH: '00', mm: '00' },
          endTime: { HH: '23', mm: '45' },
          days: {},
        },
        value: 0,
        blocks: 'Base',
        deleteNegative: false,
        calculationUnit: null,
        totalQuantity: null,
      },
      isLimitLoadEditToDateInterval: false,
      isLimitLoadEditToTimeInterval: false,
      isLimitLoadEditToDayInterval: false,
      isLimitLoadEditToQuarterInterval: false,
      isLimitLoadEditToMonthInterval: false,
      isChangetUnitModalLoading: false,
      isQuantityLoading: false,
      blocks: ['Base', 'Base-Peak'],
      isChangeUnitModalOpen: false,
      lodeCurveItemId: null,
      selectionMetaData: [],
      selectionStart: null,
      selectionEnd: null,
      selectionStartTS: null,
      selectionEndTS: null,
      selectedUnit: null,
      selectedFrequency: null,
      unitValues: {
        new: null,
        old: null,
      },
      isLoading: false,
      isRendered: false,
      isShowupdate: false,
      calcEdits: [],
      metaEdits: [],
      logs: {},
      metaDataRequests: [],
      lastSavedLoad: null,
      minimumChartValue: 0,
      maximumChartValue: 0,
      xAxisPlotBands: [],
      xAxisPlotNameFilterOption: {
        CUSTOM_DATE_RANGE: 'custom date range',
      },
      isOperationOverlayVisible: false,
      typeOfLoadedChart: 'stockChart',
      dragPointEdits: [],
      inProgressCalcEachApiCount: 0,
      isShowActionDropDown: false,
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      vueBasedProcessPreview: {
        isVisible: false,
        params: '',
        flowId: null,
        executionUrl: null,
      },
      isRunActionLoadingModalVisible: false,
      isTagManagerVisible: false,
    };
  },
  props: {
    loadProfile: Object,
    accessLevel: String,
    isAddOnly: {
      type: Boolean,
      defualt: false,
    },
    database: Object,
    tagStorageMode: {
      type: String,
      default: null,
    },
  },
  methods: {
    onDescriptionInput(element) {
      this.timeseries.description = element.target.innerText;
    },
    consoleLogMetadata() {
      // Avoid mutating the original
      let loadProfileCopy = JSON.parse(JSON.stringify(this.loadProfile));

      delete loadProfileCopy.data;
      console.log(loadProfileCopy);
    },
    async openTimeSerierLogs() {
      this.isShowupdate = true;
      if (this.logs[this.timeseries.id] === undefined) {
        await this.getLogs(this.timeseries.id);
        this.$refs.loadProfileLogModalRef.updateData(
          this.logs[this.timeseries.id]
        );
      } else {
        setTimeout(() => {
          this.$refs.loadProfileLogModalRef.updateData(
            this.logs[this.timeseries.id]
          );
        }, 50);
      }
    },
    closeTimeSerierLogs() {
      this.isShowupdate = false;
    },
    //TODO: formtNumber and displayFormat should be merged
    // but must carefully test all cases
    formatNumber(value, unit) {
      if (value == null || unit == null) {
        return 'Nicht vorhanden';
      } else {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return (
          val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ' + unit
        );
      }
    },
    displayFormat(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    fetchData() {
      if (this.loadProfile) {
        // Create non reactive copy
        let copySeries = JSON.parse(JSON.stringify(this.loadProfile));

        // Add missing malo,melo to some loads
        if (typeof copySeries.supplyPoint == 'string') {
          copySeries.supplyPoint = { maLoID: null, meLoID: null };
        }
        if (!Array.isArray(copySeries.tags)) {
          copySeries.tags = [];
        }

        this.seriesList[0] = copySeries;
      }
    },
    openTagManager() {
      this.isTagManagerVisible = true;
    },
    closeTagManager() {
      this.isTagManagerVisible = false;
    },
    async onTagManagerChange({ previousTags, nextTags }) {
      const sourceTags = JSON.parse(
        JSON.stringify(
          this.timeseries?.tags === undefined ? null : this.timeseries.tags
        )
      );
      const prev = JSON.parse(JSON.stringify(previousTags || []));
      const next = JSON.parse(JSON.stringify(nextTags || []));
      if (JSON.stringify(prev) === JSON.stringify(next)) return;

      const dbTags =
        (await this.persistNewTagsToDatabaseSchema(prev, next)) ||
        this.parseDatabaseTags(this.database?.tags);

      const previousStoredTags = this.convertModalTagsForStorage(
        prev,
        sourceTags,
        dbTags
      );
      const nextStoredTags = this.convertModalTagsForStorage(
        next,
        sourceTags,
        dbTags
      );
      if (JSON.stringify(previousStoredTags) === JSON.stringify(nextStoredTags))
        return;

      this.$set(this.timeseries, 'tags', nextStoredTags);
      this.persistTags(previousStoredTags, nextStoredTags);
    },
    persistTags(previousTags, nextTags = this.timeseries.tags) {
      this.$set(this.timeseries, 'updated', Date.now());
      this.saveSeriesWithChanges(false);
      this.setMetaEdit(
        'tags',
        previousTags,
        JSON.parse(JSON.stringify(nextTags))
      );
    },
    parseDatabaseTags(tags) {
      if (Array.isArray(tags)) return JSON.parse(JSON.stringify(tags));
      if (typeof tags !== 'string' || !tags.trim()) return [];
      try {
        const parsed = JSON.parse(tags);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    isTagObject(tag) {
      return !!tag && typeof tag === 'object' && !Array.isArray(tag);
    },
    getTagStorageMode(sourceTags, forcedMode = null) {
      if (forcedMode === 'objects' || forcedMode === 'ids') {
        return forcedMode;
      }
      if (this.tagStorageMode === 'objects' || this.tagStorageMode === 'ids') {
        return this.tagStorageMode;
      }
      if (!Array.isArray(sourceTags) || !sourceTags.length) return 'ids';
      return sourceTags.some((tag) => this.isTagObject(tag))
        ? 'objects'
        : 'ids';
    },
    parseTimeseriesTagsToObjects(tags) {
      if (!Array.isArray(tags) || !tags.length) return [];

      if (tags.some((tag) => this.isTagObject(tag))) {
        return tags
          .map((tag) => ({
            id: tag?.id || null,
            name: this.normalizeTagName(tag?.name || tag?.n),
            color: tag?.color || tag?.c || '#4f46e5',
          }))
          .filter((tag) => !!tag.name);
      }

      const databaseTags = this.parseDatabaseTags(this.database?.tags);
      const databaseTagById = new Map(
        databaseTags.map((tag) => [String(tag?.id), tag])
      );
      return tags
        .map((tagId) => {
          const match = databaseTagById.get(String(tagId));
          return {
            id: match?.id || tagId,
            name: this.normalizeTagName(match?.n || match?.name || `${tagId}`),
            color: match?.c || match?.color || '#4f46e5',
          };
        })
        .filter((tag) => !!tag.name);
    },
    getDatabaseTagIdByName(tagName, databaseTags = []) {
      const normalizedName = this.normalizeTagName(tagName).toLowerCase();
      if (!normalizedName) return null;
      const match = (databaseTags || []).find((tag) => {
        const dbName = this.normalizeTagName(tag?.n || tag?.name).toLowerCase();
        return dbName === normalizedName;
      });
      return match?.id ?? null;
    },
    normalizeTagName(tag) {
      if (typeof tag === 'string') return tag.trim();
      const name = tag?.name || tag?.n;
      return typeof name === 'string' ? name.trim() : '';
    },
    convertModalTagsForStorage(
      modalTags = [],
      sourceTags = this.timeseries?.tags,
      databaseTags = this.parseDatabaseTags(this.database?.tags)
    ) {
      const normalizedModalTags = (modalTags || [])
        .map((tag) => ({
          id: tag?.id ?? null,
          name: this.normalizeTagName(tag?.name || tag?.n),
          color: tag?.color || tag?.c || '#4f46e5',
        }))
        .filter((tag) => !!tag.name);

      const storageMode = this.getTagStorageMode(
        sourceTags,
        this.tagStorageMode
      );
      if (storageMode === 'objects') {
        return normalizedModalTags.map((tag) => ({
          name: tag.name,
          color: tag.color,
        }));
      }

      const ids = normalizedModalTags
        .map((tag) =>
          tag.id !== null && tag.id !== undefined
            ? tag.id
            : this.getDatabaseTagIdByName(tag.name, databaseTags)
        )
        .filter(
          (id) => id !== null && id !== undefined && String(id).trim() !== ''
        );

      if (ids.length === normalizedModalTags.length) {
        return [...new Set(ids)];
      }

      return normalizedModalTags.map((tag) => ({
        name: tag.name,
        color: tag.color,
      }));
    },
    isTagAlreadyKnown(tag, collection = []) {
      const normalizedName = this.normalizeTagName(tag).toLowerCase();
      if (!normalizedName) return true;
      return collection.some(
        (existingTag) =>
          this.normalizeTagName(existingTag).toLowerCase() === normalizedName
      );
    },
    async persistNewTagsToDatabaseSchema(previousTags = [], nextTags = []) {
      if (!this.database?.name || !this.user) return;

      const existingDbTags = this.parseDatabaseTags(this.database.tags);
      const updatedDatabaseTags = JSON.parse(JSON.stringify(existingDbTags));
      const dbTagById = new Map(
        updatedDatabaseTags.map((tag, index) => [String(tag?.id), index])
      );
      let isSchemaChanged = false;

      (nextTags || []).forEach((tag) => {
        const tagId = tag?.id;
        if (
          tagId === null ||
          tagId === undefined ||
          String(tagId).trim() === ''
        )
          return;

        const existingIndex = dbTagById.get(String(tagId));
        if (existingIndex === undefined) return;

        const nextName = this.normalizeTagName(tag?.name || tag?.n);
        const nextColor =
          tag?.color || tag?.c || updatedDatabaseTags[existingIndex]?.c;
        if (nextName && updatedDatabaseTags[existingIndex].n !== nextName) {
          updatedDatabaseTags[existingIndex].n = nextName;
          isSchemaChanged = true;
        }
        if (nextColor && updatedDatabaseTags[existingIndex].c !== nextColor) {
          updatedDatabaseTags[existingIndex].c = nextColor;
          isSchemaChanged = true;
        }
      });

      const isEditOnlyOperation =
        Array.isArray(previousTags) &&
        Array.isArray(nextTags) &&
        previousTags.length === nextTags.length;

      if (!isEditOnlyOperation) {
        const timestamp = Date.now();
        let newTagIndex = 0;

        (nextTags || []).forEach((nextTag) => {
          const nextName = this.normalizeTagName(nextTag?.name || nextTag?.n);
          if (!nextName) return;

          const nextId = nextTag?.id;
          if (
            nextId !== null &&
            nextId !== undefined &&
            String(nextId).trim() !== '' &&
            dbTagById.has(String(nextId))
          ) {
            return;
          }

          if (this.isTagAlreadyKnown(nextTag, updatedDatabaseTags)) return;

          updatedDatabaseTags.push({
            c: nextTag?.color || nextTag?.c || '#4f46e5',
            n: nextName,
            id: timestamp + newTagIndex,
          });
          newTagIndex += 1;
          isSchemaChanged = true;
        });
      }

      if (!isSchemaChanged) return existingDbTags;

      const formData = new FormData();
      formData.append('value', JSON.stringify(updatedDatabaseTags));

      try {
        await updateTableSchema(
          this.user,
          this.database.name,
          formData,
          'tags'
        );
        this.$set(this.database, 'tags', updatedDatabaseTags);
        return updatedDatabaseTags;
      } catch (error) {
        return existingDbTags;
      }
    },
    exportFile() {
      this.$emit('download', this.timeseries, true);

      this.isDownloading = true;
      setTimeout(() => {
        this.isDownloading = false;
      }, 5000);
    },
    //show share Modal
    showModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },
    close() {
      this.$emit('close');
    },
    showMoreOperations() {
      this.isMoreOperationsVisible = true;

      // scroll to bottom of side-bar
      /*
      this.$nextTick(function () {
        var objDiv = document.getElementsByClassName("side-panel")[0];
        objDiv.scrollTop = objDiv.scrollHeight;
      });
      */
    },
    hideMoreOperations() {
      this.isMoreOperationsVisible = false;
    },
    calculateEach(operation) {
      this.isLoading = true;
      this.inProgressCalcEachApiCount += 1;
      this.setCalcEdit(
        this.operationParams.value,
        this.operationParams.calculationUnit,
        operation
      );

      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/calculate-each';

      url += '?operation=' + operation;
      url += '&value=' + this.operationParams.value;
      url += this.getCriteriaURL();

      if (this.operationParams.calculationUnit)
        url += '&calculation_unit=' + this.operationParams.calculationUnit;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      var payload = {
        loadCurve: this.timeseries,
      };

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then((json) => {
          this.inProgressCalcEachApiCount -= 1;
          this.addNewSeries(json, this.inProgressCalcEachApiCount);
        })
        .catch((e) => {
          if (!(e instanceof DOMException)) {
            this.toggleRedraw();
          }
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          }
        });
    },
    getNewLoadID(id) {
      let newID = new Date().getTime();
      let oldID = id.split('_')[id.split('_').length - 1];

      // Replace and return
      return id.replace(oldID, newID);
    },
    deleteNegativeValues() {
      this.isLoading = true;

      this.setCalcEdit(0, null, 'delete-negative-values');

      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/delete-negative-values';

      // add periods
      url += '?' + this.getCriteriaURL().replace(/^&/, '');

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      var payload = {
        loadCurve: this.timeseries,
      };

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then((json) => {
          this.addNewSeries(json);
        })
        .catch((e) => {
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          }
        });
    },
    resetDateInterval(isCalledFromCreated) {
      const start = timestampToCETConvertor(this.timeseries.start);
      const end = timestampToCETConvertor(this.timeseries.end);

      this.operationParams.intervals.startDate = start;
      this.operationParams.intervals.endDate = end;
      this.filterXAxisPlotBands(
        this.xAxisPlotNameFilterOption.CUSTOM_DATE_RANGE
      );
      // update settings
      if (!isCalledFromCreated) {
        setTimeout(() => {
          this.saveCalculationSetting(
            'isLimitLoadEditToDateInterval',
            this.isLimitLoadEditToDateInterval
          );
        }, 1000);
      }

      // calc metadata
      setTimeout(() => {
        this.handleSelectionChange();
      }, 50);
    },
    resetTimeInterval() {
      var isTimeIntervalChanged = false;
      const start = { HH: '00', mm: '00' };
      const end = { HH: '23', mm: '45' };

      // Compare, if changed recalculate metadata
      if (this.operationParams.intervals.startTime != start)
        isTimeIntervalChanged = true;
      if (this.operationParams.intervals.endTime != end)
        isTimeIntervalChanged = true;

      this.operationParams.intervals.startTime = start;
      this.operationParams.intervals.endTime = end;
      // update settings
      setTimeout(() => {
        this.saveCalculationSetting(
          'isLimitLoadEditToTimeInterval',
          this.isLimitLoadEditToTimeInterval
        );
      }, 1000);

      // calc metadata
      if (isTimeIntervalChanged) this.handleSelectionChange();
    },
    resetDayInterval() {
      var isDaySelected = false;
      for (let day of this.days) {
        if (day.selected == true) {
          isDaySelected = true;
          this.filterXAxisPlotBands(day.text);
        }
        day.selected = false;
      }

      // update settings
      setTimeout(() => {
        this.saveCalculationSetting(
          'isLimitLoadEditToDayInterval',
          this.isLimitLoadEditToDayInterval
        );
      }, 1000);

      // calc metadata
      if (isDaySelected) this.handleSelectionChange();
    },

    resetQuarterInterval() {
      var isQuarterSelected = false;
      for (let quarter of this.quarters) {
        if (quarter.selected == true) {
          isQuarterSelected = true;
          this.filterXAxisPlotBands(quarter.text);
        }
        quarter.selected = false;
      }
      // update settings
      setTimeout(() => {
        this.saveCalculationSetting(
          'isLimitLoadEditToQuarterInterval',
          this.isLimitLoadEditToQuarterInterval
        );
      }, 1000);

      // calc metadata
      if (isQuarterSelected) this.handleSelectionChange();
    },

    resetMonthInterval() {
      var isMonthSelected = false;
      for (let month of this.monthsInterval) {
        if (month.selected) {
          isMonthSelected = true;
          this.filterXAxisPlotBands(month.name);
        }
        month.selected = false;
      }

      // update settings
      setTimeout(() => {
        this.saveCalculationSetting(
          'isLimitLoadEditToMonthInterval',
          this.isLimitLoadEditToMonthInterval
        );
      }, 1000);

      // calc metadata
      if (isMonthSelected) this.handleSelectionChange();
    },

    saveNewSeries() {
      this.isSaving = true;
      this.isLoading = true;

      // Make copy of series & delete is saved property
      let copySeries = JSON.parse(JSON.stringify(this.timeseries));

      // Remove frontend keys
      const keysToRemove = ['loading', 'isLoading', 'isSaved', 'selected'];
      for (let k of keysToRemove) {
        delete copySeries[k];
      }

      copySeries.created = Date.now();

      this.$emit('saveFile', copySeries, false);
      this.lastSavedLoad = copySeries;

      // Save logs
      if (this.metaEdits.length != 0) this.saveMetaLogs();

      this.saveCalcLogs(copySeries.id);
      if (this.dragPointEdits.length != 0)
        this.saveDragDataPointLogs(copySeries.id);

      // Add property to load after save
      this.$set(this.seriesList[this.selectedSeriesIndex], 'isSaved', true);
      setTimeout(() => {
        this.isSaving = false;
        this.isLoading = false;
      }, 2000);
    },
    saveSeriesWithChanges(evaluateLoad) {
      this.loading = true;
      this.$emit('saveFile', this.timeseries, evaluateLoad);

      // Add flow as reference for new changes
      this.lastSavedLoad = JSON.parse(JSON.stringify(this.timeseries));

      // TODO: remove when using created in (watch{})
      setTimeout(() => {
        this.loading = false;
      }, 15000);
    },
    getNameWithoutTimestamp(name) {
      let regex = /^[0-9]{13}_{1}/gm;
      return name.split(regex)[1];
    },
    toggleMonth(month) {
      // toggle selected
      if (!month.selected) {
        this.xAxisPlotBands.push(
          this.getPlotBandStructureWithValue(
            moment
              .tz(month.periodStart, 'Europe/Berlin')
              .startOf('month')
              .valueOf(),
            moment.tz(month.periodEnd, 'Europe/Berlin').endOf('month').valueOf()
            // '#86fcaf',
            // month.text,
            // month.name
          )
        );
      }
      if (month.selected) {
        this.filterXAxisPlotBands(month.text);
      }
      month.selected = !month.selected;

      /*
      // remove warning
      this.periodAlerts = this.periodAlerts.filter(
          e => !e.id.includes(month.value)
        );
        */

      // Set months with new value
      this.$set(this.monthsInterval, month.value, month);

      // check overlapping
      this.checkOverlappingSelection();

      // calc metadata
      this.handleSelectionChange();
    },
    resetCustomAlert() {
      this.periodAlerts = this.periodAlerts.filter(
        (e) => e.id != 'customOverlapping'
      );
    },
    isMonthOverlappingCustomDate(customStart, customEnd) {
      // Find relevant months
      const relevantMonths = this.selectedMonths.filter(
        (e) => e.periodStart <= customEnd && e.periodEnd >= customStart
      );

      const monthsCount = relevantMonths.length;
      if (monthsCount > 0) {
        // Check overlapping
        const isMonthStartOverlapping =
          relevantMonths[0].periodStart != customStart;
        const isMonthEndOverlapping =
          relevantMonths[monthsCount - 1].periodEnd != customEnd;
        const isOverlapping = isMonthStartOverlapping || isMonthEndOverlapping;

        if (isOverlapping) return true;
        else return false;

        // If no months return false
      } else return false;
    },
    isQuarterOverlappingCustomDate(customStart, customEnd) {
      // Find relevant months
      const relevantQuarters = this.selectedQuarters.filter(
        (e) => e.periodStart <= customEnd && e.periodEnd >= customStart
      );

      const quarterCount = relevantQuarters.length;
      if (quarterCount > 0) {
        // Check overlapping
        const isQuarterStartOverlapping =
          relevantQuarters[0].periodStart != customStart;
        const isQuarterEndOverlapping =
          relevantQuarters[quarterCount - 1].periodEnd != customEnd;
        const isOverlapping =
          isQuarterStartOverlapping || isQuarterEndOverlapping;

        if (isOverlapping) return true;
        else return false;

        // if no quarters return fals
      } else return false;
    },

    getMissingMonthsInQuarter(monthsOfQuarter) {
      const selectedMonths = this.selectedMonths;

      const selectedMonthsOfQuarter = monthsOfQuarter.filter((e) =>
        selectedMonths.some((el) => e.value == el.value)
      );
      const isMonthOfQuarterSelected = selectedMonthsOfQuarter.length > 0;

      if (isMonthOfQuarterSelected) {
        // Define comparer to check if two items are equal
        const isSameMonth = (a, b) => a.value === b.value;

        // Get items that only occur in the monthsArray array,
        // using the compareFunction to determine equality.
        const isNotSelected = (left, right, compareFunction) =>
          left.filter(
            (leftValue) =>
              !right.some((rightValue) =>
                compareFunction(leftValue, rightValue)
              )
          );

        const onlyInQuarter = isNotSelected(
          monthsOfQuarter,
          selectedMonths,
          isSameMonth
        );
        return onlyInQuarter;
      } else return [];
    },
    checkOverlappingSelection() {
      // Check custom-date
      let customDateWarning = false;
      if (this.isLimitLoadEditToDateInterval) {
        // Get selection range
        const startDate = getCETTimeStampFromDate(
          this.operationParams.intervals.startDate
        );
        const endDate = getCETTimeStampFromDate(
          this.operationParams.intervals.endDate
        );

        // Check overlapping with custom-date-selection
        const isMonthOverlapping = this.isMonthOverlappingCustomDate(
          startDate,
          endDate
        );
        const isQuarterOverlapping = this.isQuarterOverlappingCustomDate(
          startDate,
          endDate
        );

        if (isMonthOverlapping || isQuarterOverlapping) {
          const displayStart = new Date(
            this.operationParams.intervals.startDate
          ).toLocaleDateString();
          const displayEnd = new Date(
            this.operationParams.intervals.endDate
          ).toLocaleDateString();
          const message = `zwischen ${displayStart} und ${displayEnd}`;
          customDateWarning = true;

          // Push only one customOverlapping event
          const isCustomDateAlertActive = this.periodAlerts.some(
            (e) => e.id == 'customOverlapping'
          );
          if (!isCustomDateAlertActive) {
            this.periodAlerts.push({
              id: 'customOverlapping',
              message: message,
              display: true,
            });
          }

          // Reset customAlert
        } else {
          this.resetCustomAlert();
        }
      } else {
        this.resetCustomAlert();
      }

      // Check quarters and months
      if (!customDateWarning) {
        let allMonths = [];
        for (const quarter of this.selectedQuarters) {
          // Get all months in quarter
          const monthsInQuarter = this.getMonthsFromRange(
            quarter.periodStart,
            quarter.periodEnd
          );

          // Check if all months for quarter are selected
          const months = this.getMissingMonthsInQuarter(monthsInQuarter);
          allMonths = allMonths.concat(months);

          // Display error for missing months
          months.forEach((e) => {
            const message = `${quarter.text} und ${e.text}`;
            const alertId = `${quarter.value}_${e.value}`;

            const alertExists =
              this.periodAlerts.findIndex((e) => e.id == alertId) != -1;

            // Push only new alerts
            if (!alertExists) {
              this.periodAlerts.push({
                id: alertId,
                message: message,
                display: true,
              });
            }
          });
        }

        this.periodAlerts = this.periodAlerts.filter((e) =>
          allMonths.some((el) => e.id.includes(el.value))
        );
      }
    },
    toggleDay(day) {
      // toggle selected
      if (!day.selected) {
        for (
          var d = new Date(this.minimumChartValue);
          d <= new Date(this.maximumChartValue);
          d.setDate(d.getDate() + 1)
        ) {
          if (d.getDay() == (day.value == 6 ? 0 : day.value + 1)) {
            this.xAxisPlotBands.push(
              this.getPlotBandStructureWithValue(
                moment.tz(d, 'Europe/Berlin').startOf('day').valueOf(),
                moment.tz(d, 'Europe/Berlin').endOf('day').valueOf()
                // '#ffe24cbf',
                // day.text,
                // day.name
              )
            );
          }
        }
      }
      if (day.selected) {
        this.filterXAxisPlotBands(day.text);
      }
      day.selected = !day.selected;

      // Set day with new value
      this.$set(this.days, day.value, day);

      // calc metadata
      this.handleSelectionChange();
    },
    toggleQuarter(quarter) {
      if (!quarter.selected) {
        this.xAxisPlotBands.push(
          this.getPlotBandStructureWithValue(
            moment
              .tz(quarter.periodStart, 'Europe/Berlin')
              .clone()
              .startOf('quarter')
              .valueOf(),
            moment
              .tz(quarter.periodStart, 'Europe/Berlin')
              .clone()
              .endOf('quarter')
              .valueOf()
            // '#ffa8bd',
            // quarter.text,
            // quarter.text
          )
        );
      }
      if (quarter.selected) {
        this.filterXAxisPlotBands(quarter.text);
      }
      quarter.selected = !quarter.selected;
      this.$set(this.quarters, quarter.value, quarter);

      // check overlapping
      this.checkOverlappingSelection();

      // remove warning
      if (!quarter.selected) {
        this.periodAlerts = this.periodAlerts.filter(
          (e) => !e.id.includes(quarter.value)
        );
      }

      // calc metadata
      this.handleSelectionChange();
    },
    toggleDeleteNegative() {
      this.operationParams.deleteNegative =
        !this.operationParams.deleteNegative;
    },
    switchSeriesDown() {
      if (!this.isFirstLoad) {
        this.isLoading = true;
        const oldUnitValue = this.activeUnit;
        this.selectedSeriesIndex -= 1;
        this.activeUnit = oldUnitValue;

        // Get metadata if not exists
        if (this.isAnyCriteraSelected && !this.selectedMetaData) {
          this.calculateMetaData();
        } else {
          this.toggleRedraw();
        }

        // Reset totalQuantity
        this.operationParams.totalQuantity = null;
      }
    },
    switchSeriesUp() {
      if (!this.isLastLoad) {
        this.isLoading = true;

        const oldUnitValue = this.activeUnit;
        this.selectedSeriesIndex += 1;
        this.activeUnit = oldUnitValue;

        // Get metadata if not exists
        if (this.isAnyCriteraSelected && !this.selectedMetaData) {
          this.calculateMetaData();
        } else {
          this.toggleRedraw();
        }

        // Reset totalQuantity
        this.operationParams.totalQuantity = null;
      }
    },
    toggleRedraw() {
      this.redrawChart = true;
      setTimeout(() => {
        this.redrawChart = false;
        this.isLoading = false;
        this.isQuantityLoading = false;
        this.toggleOperationOverlay(false);
      }, 500);
    },
    setCalculationUnit(unit) {
      if (unit == this.operationParams.calculationUnit) {
        this.operationParams.calculationUnit = null;
      } else this.operationParams.calculationUnit = unit;

      // Keep till we know whats happening
      // untill then only one button can be pressed

      /*
      switch (this.operationParams.calculationUnit) {
        case null:
          this.operationParams.calculationUnit = unit;
          break;

        case "percentage":
          if (this.operationParams.calculationUnit !== unit) {
            this.operationParams.calculationUnit = "kWh_percentage";
          } else {
            this.operationParams.calculationUnit = null;
          }

          break;

        case "kWh":
          if (this.operationParams.calculationUnit !== unit) {
            this.operationParams.calculationUnit = "kWh_percentage";
          } else {
            this.operationParams.calculationUnit = null;
          }
          break;

        case "kWh_percentage":
          if (unit === "kWh") {
            this.operationParams.calculationUnit = "percentage";
          } else {
            this.operationParams.calculationUnit = "kWh";
          }
          break;

        default:
          this.operationParams.calculationUnit = null;
          break;
      }
      */
    },
    closeUnitModal() {
      this.isChangeUnitModalOpen = false;
      this.lodeCurveItemId = null;
    },
    handleChartMinimumValue(min) {
      this.minimumChartValue = min;
    },
    handleChartMaximumValue(max) {
      this.maximumChartValue = max;
    },
    handleChartSelectionChange(min, max) {
      //this.isLoading = true;

      // On selection change remove all metaData
      //this.selectionMetaData = [];
      this.selectionStartTS = min;
      this.selectionEndTS = max;
      /*
      // Reset zoom will trigger false
      if (typeof min == "number" && typeof max == "number") {
        this.calculateMetaData(null);
        this.handleDateRange();
      } else if (this.isSetSelectionDateRange) this.toggleSelectionDateRange();
      else this.isLoading = false;
      */
    },
    handleSelectionChange() {
      if (
        convertDateToCETDate(this.operationParams.intervals.endDate) >
          convertDateToCETDate(this.operationParams.intervals.startDate) &&
        (this.operationParams.intervals.startDate !=
          timestampToCETConvertor(this.timeseries.start) ||
          this.operationParams.intervals.endDate !=
            timestampToCETConvertor(this.timeseries.end)) &&
        this.isLimitLoadEditToDateInterval
      ) {
        const isDateTimePlotBandExists = this.xAxisPlotBands.find(
          (plotBand) =>
            plotBand.label &&
            plotBand.label.text ==
              this.xAxisPlotNameFilterOption.CUSTOM_DATE_RANGE
        );
        if (!isDateTimePlotBandExists) {
          this.xAxisPlotBands.push(
            this.getPlotBandStructureWithValue(
              getCETTimeStampFromDate(this.operationParams.intervals.startDate),
              getCETTimeStampFromDate(this.operationParams.intervals.endDate)
              // '#d9ffab',
              // this.xAxisPlotNameFilterOption.CUSTOM_DATE_RANGE,
              // this.xAxisPlotNameFilterOption.CUSTOM_DATE_RANGE
            )
          );
        } else {
          this.xAxisPlotBands = this.xAxisPlotBands.map((plotBand) =>
            plotBand.label &&
            plotBand.label.text ==
              this.xAxisPlotNameFilterOption.CUSTOM_DATE_RANGE
              ? {
                  ...plotBand,
                  from: getCETTimeStampFromDate(
                    this.operationParams.intervals.startDate
                  ),
                  to: getCETTimeStampFromDate(
                    this.operationParams.intervals.endDate
                  ),
                }
              : plotBand
          );
        }
      }
      this.selectionMetaData.splice(0);
      if (this.isAnyCriteraSelected) this.calculateMetaData();

      // check overlapping
      this.checkOverlappingSelection();
    },
    async calculateMetaData(load = null) {
      if (this.isRendered) {
        // Abort current requests
        this.isLoading = true;
        this.metaDataRequests.forEach((e) => e.abort());

        var url = process.env.VUE_APP_TS_CALCULATION_API;
        url += '/calculate-metadata';
        url += '?' + this.getCriteriaURL().replace(/^&/, '');

        let myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );
        myHeaders.append('content-type', 'application/json');

        // if no load in params, use selected ts
        if (load == null) load = this.timeseries;

        // Modify data, send only selected values to decrease request time
        let copySeries = JSON.parse(JSON.stringify(load));
        if (!copySeries.unit) copySeries.unit = this.activeUnit;

        // We only modify TS if the request is made for selection
        if (this.isAnyCriteraSelected) {
          // set quantity loading
          this.isQuantityLoading = true;
          // Only for display purpose of selected start/end
          this.selectionStart = this.getFormatedDateInCET(
            this.operationParams.intervals.startDate
          );
          this.selectionEnd = this.getFormatedDateInCET(
            this.operationParams.intervals.endDate
          );
        }

        var payload = {
          loadCurve: copySeries,
        };

        // Reset controllers
        this.selectionMetaData.splice(0);

        // Create abort controller
        const controller = new AbortController();
        const signal = controller.signal;
        this.$set(
          this.metaDataRequests,
          this.metaDataRequests.length,
          controller
        );

        return await fetch(url, {
          body: JSON.stringify(payload),
          headers: myHeaders,
          method: 'POST',
          signal: signal,
        })
          .then(async (response) => {
            if (response.status == 200) return response.json();
            else if (response.status == 401) {
              throw new Error('Access Token has expired');
            } else throw new Error('CORS');
          })
          .then(async (json) => {
            if (this.isAnyCriteraSelected) {
              // Delete data, keep only metadata
              delete json.data;

              // Set metadata on last index
              this.$set(
                this.selectionMetaData,
                this.selectionMetaData.length,
                json
              );
              this.operationParams.totalQuantity = null;

              // Redraw chart
              this.toggleRedraw();
              this.isQuantityLoading = false;
              return json;
            } else {
              this.isQuantityLoading = false;
              this.isLoading = false;
              return json;
            }
          })
          .catch((e) => {
            //TODO: If error CORS show modal (emit in parent)
            if (e == 'Error: Access Token has expired') {
              localStorage.clear(),
                this.$router.push({
                  name: 'auth',
                  params: { message: 'Sitzung abgelaufen' },
                });
            } else {
              if (!(e instanceof DOMException)) {
                this.showToaster(
                  'Fehler in der Kalkulation, bitte erneut probieren',
                  'Fehlerhaft !',
                  'danger'
                );
                this.toggleRedraw();
                this.isQuantityLoading = false;
              }
              this.closeUnitModal();
            }
          });
      }
    },
    setUserSettings() {
      let settings = store.state.userSettings;

      // Loop over all setting keys
      for (let k of Object.keys(settings)) {
        // If key exists set settings val as default
        if (k in this) this[k] = settings[k];
      }
    },
    async saveCalculationSetting(key, value) {
      var settings = {};
      settings[key] = value;

      await this.$store.dispatch('putUserSettings', {
        settings,
      });
    },
    scaleQuantity() {
      this.isLoading = true;
      this.isQuantityLoading = true;

      this.setCalcEdit(this.totalQuantity, null, 'scale');

      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/scale-quantity';
      url += '?to_quantity=' + this.totalQuantity;

      url += this.getCriteriaURL();

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      var payload = {
        loadCurve: this.timeseries,
      };

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'post',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then((json) => {
          this.addNewSeries(json);
        })
        .catch((e) => {
          //TODO: If error CORS show modal (emit in parent)

          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          }
          this.isLoading = false;
          this.isQuantityLoading = false;
        });
    },
    getCriteriaURL() {
      var url = '';

      if (this.isLimitLoadEditToDateInterval) {
        url +=
          '&date_start=' +
          getCETTimeStampFromDate(this.operationParams.intervals.startDate);
        url +=
          '&date_end=' +
          getCETTimeStampFromDate(this.operationParams.intervals.endDate);
      }

      if (this.isLimitLoadEditToTimeInterval) {
        url += '&time_start=' + this.startTime;
        url += '&time_end=' + this.endTime;
      }

      if (this.selectedDays.length != 0) url += '&days=';
      this.selectedDays.forEach((e, idx) => {
        if (idx == 0) url += e.value;
        else if (idx != 0) url += ',' + e.value;
      });

      if (this.selectedMonths.length != 0) url += '&months=';
      this.selectedMonths.forEach((e, idx) => {
        if (idx == 0) url += e.value;
        else if (idx != 0) url += ',' + e.value;
      });

      if (this.selectedQuarters.length != 0) url += '&quarters=';
      this.selectedQuarters.forEach((e, idx) => {
        if (idx == 0) url += e.value;
        else if (idx != 0) url += ',' + e.value;
      });

      return url;
    },
    getQuarter(date) {
      return (
        'Q' + Math.ceil((date.month() + 1) / 3) + ' ' + (date.year() % 100)
      );
    },
    listQuarters(sDate, eDate) {
      // Get first day of year, quarter can't start in middle of the year
      sDate = sDate.startOf('year');
      eDate = eDate.endOf('year');

      //sDate.setDate(2);

      let startQ = this.getQuarter(sDate);
      let endQ = this.getQuarter(eDate);
      // Get last day of quarter
      let firstQstart = sDate.startOf('month');
      let firstQend = moment().month(
        JSON.parse(JSON.stringify(firstQstart.month())) + 2
      );

      firstQend = firstQend.endOf('month');
      let result = [
        {
          id: Math.round(Math.random() * 100000 + new Date().getTime()),
          text: startQ,
          value: startQ.replace(' ', '_'),
          periodStart: sDate.valueOf(),
          periodEnd: firstQend.valueOf(),
          selected: false,
        },
      ];

      // Add 3 months to get next quarter
      sDate.month(sDate.month() + 3);
      while (startQ !== endQ) {
        // Get caption
        startQ = this.getQuarter(sDate);
        // Get first day of quarter
        const firstDay = sDate.startOf('month');

        // Remove one day to get last day of quarter
        const lastDay = moment()
          .month(JSON.parse(JSON.stringify(sDate.month())) + 2)
          .endOf('month');
        result.push({
          id: Math.round(Math.random() * 100000 + new Date().getTime()),
          text: startQ,
          value: startQ.replace(' ', '_'),
          timestamp: sDate.valueOf(),
          periodStart: firstDay.valueOf(),
          periodEnd: lastDay.valueOf(),
          selected: false,
        });
        // Add 3 months to get next quarter
        sDate.month(sDate.month() + 3);
      }

      return result;
    },

    syncDateRange(type) {
      if (
        Math.floor(this.$refs.Chart.chart.xAxis[0].min) ==
          getCETTimeStampFromDate(this.operationParams.intervals.startDate) &&
        Math.floor(this.$refs.Chart.chart.xAxis[0].max) ==
          getCETTimeStampFromDate(this.operationParams.intervals.endDate)
      )
        return;

      this.isLoading = false;
      if (type == 'chart') this.syncChartToInput();
      else this.syncInputToChart();
    },
    syncChartToInput() {
      this.operationParams.intervals.startDate = timestampToCETConvertor(
        this.selectionStartTS ? this.selectionStartTS : this.minimumChartValue
      );
      this.operationParams.intervals.endDate = timestampToCETConvertor(
        this.selectionEndTS ? this.selectionEndTS : this.maximumChartValue
      );
      this.updateChartWithDragPoints();
      this.handleSelectionChange();
    },

    syncInputToChart() {
      this.selectionStartTS = getCETTimeStampFromDate(
        this.operationParams.intervals.startDate
      );

      this.selectionEndTS = getCETTimeStampFromDate(
        this.operationParams.intervals.endDate
      ).valueOf();
      this.$refs.Chart.chart.xAxis[0].setExtremes(
        this.selectionStartTS,
        this.selectionEndTS
      );
      if (this.isSetSelectionDateRange) this.$refs.Chart.chart.showResetZoom();
      else this.$refs.Chart.chart.zoomOut();
      this.toggleRedraw();
      this.updateChartWithDragPoints();
      this.handleSelectionChange();
    },
    openChangeUnit(event, unit) {
      // this.unitValues.new = event.target ? event.target.value : event;
      this.unitValues.new = unit;
      this.unitValues.old = this.timeseries.unit;
      this.isChangetUnitModalLoading = false;
      this.isChangeUnitModalOpen = true;
    },
    async addUnitWithoutConvert() {
      // show loading
      this.isChangetUnitModalLoading = true;

      this.setMetaEdit('unit', this.timeseries.unit, this.unitValues.new, true);

      // Create copy and add unit
      let ts = JSON.parse(JSON.stringify(this.timeseries));
      ts.unit = this.unitValues.new;

      // Calc metadata
      ts = await this.calculateMetaData(ts);
      // this.timeseries.unit = this.unitValues.new;

      // Handle unit change calculation
      this.handleUnitLog(ts.quantity.value, this.timeseries.quantity.value);

      // Push to array
      this.addNewSeries(ts);

      // Close unit-modal
      this.isChangeUnitModalOpen = false;
    },
    async convertLoadFreq(value) {
      this.isLoading = true;
      this.setMetaEdit('freq', this.timeseries.freq, value, true);

      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/convert-freq';
      url += '?output_freq=' + value;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      let copySeries = JSON.parse(JSON.stringify(this.timeseries));
      var payload = {
        loadCurve: copySeries,
      };

      return fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then(async (json) => {
          // this.timeseries.unit = this.unitValues.new;
          // Handle unit change calculation

          /*
          this.handleUnitLog(
            json.quantity.value,
            this.timeseries.quantity.value
          );
          */

          await this.addNewSeries(json);

          // Reset values
          this.activeFrequency = null;
          this.$forceUpdate();
        })
        .catch((e) => {
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else {
            this.isLoading = false;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async addNewSeries(series, apiCount = 0) {
      // Remove all previous calculated loads
      this.seriesList.length = this.selectedSeriesIndex + 1;

      // Change id
      series.id = this.getNewLoadID(series.id);

      // Set series on last index
      this.$set(this.seriesList, this.seriesList.length, series);

      // Set view on newest series
      this.selectedSeriesIndex = this.seriesList.length - 1;

      // Get selection meta
      if (this.isAnyCriteraSelected) {
        await this.calculateMetaData();
      } else {
        // Redraw chart
        if (apiCount == 0) this.toggleRedraw();
      }

      // set isSaved false on newest series
      this.$set(this.seriesList[this.selectedSeriesIndex], 'isSaved', false);

      // Reset unit
      this.activeUnit = null;
      this.activeFrequency = null;
    },
    convertLoadUnit() {
      // show loading
      this.isChangetUnitModalLoading = true;

      this.setMetaEdit('unit', this.timeseries.unit, this.unitValues.new, true);

      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/convert-unit';
      url += '?output_unit=' + this.unitValues.new;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      let copySeries = JSON.parse(JSON.stringify(this.timeseries));
      var payload = {
        loadCurve: copySeries,
      };

      return fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then((json) => {
          // this.timeseries.unit = this.unitValues.new;
          // Handle unit change calculation
          this.handleUnitLog(
            json.quantity.value,
            this.timeseries.quantity.value
          );

          this.addNewSeries(json);

          // Reset values
          this.isChangeUnitModalOpen = false;
          this.activeUnit = null;
        })
        .catch((e) => {
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else {
            this.isLoading = false;
            this.closeUnitModal();
          }
        });
    },
    getMonthsFromRange(startRange, endRange) {
      const monthsInRange = [];

      const rangeStart = convertDateToCETDate(startRange);
      const rangeStartYear = rangeStart.year();
      const rangeStartMonth = ('0' + (rangeStart.month() + 1)).slice(-2);
      const rangeStartDay = ('0' + rangeStart.date()).slice(-2);

      const rangeEnd = convertDateToCETDate(endRange);
      const rangeEndYear = rangeEnd.year();
      const rangeEndMonth = ('0' + (rangeEnd.month() + 1)).slice(-2);
      const rangeEndDay = ('0' + rangeEnd.date()).slice(-2);

      const startDate = `${rangeStartYear}-${rangeStartMonth}-${rangeStartDay}`;
      const endDate = `${rangeEndYear}-${rangeEndMonth}-${rangeEndDay}`;

      const start = startDate.split('-');
      const end = endDate.split('-');
      const startYear = parseInt(start[0]);
      const endYear = parseInt(end[0]);
      const dates = [];

      for (let i = startYear; i <= endYear; i++) {
        let endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        let startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          let j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          let month = j + 1;
          let displayMonth = month < 10 ? '0' + month : month;
          dates.push([i, displayMonth, '01'].join('-'));
        }
      }
      for (let index = 0; index < dates.length; index++) {
        let month = new Date(dates[index]);

        const germenDate = convertDateToCETDate(dates[index]);
        monthsInRange.push({
          id: Math.round(Math.random() * 100000 + new Date().getTime()),
          name: month.toLocaleString('en', { month: 'long' }),
          value:
            month.toLocaleString('en', { month: 'short' }) +
            '_' +
            month.toLocaleDateString('en', { year: '2-digit' }),
          text:
            this.months[
              month.toLocaleString('en', { month: 'long' })
            ].substring(0, 3) +
            '. ' +
            month.toLocaleDateString('en', { year: '2-digit' }),
          periodStart: germenDate.startOf('month').valueOf(),
          periodEnd: germenDate.endOf('month').valueOf(),
          selected: false,
        });
      }

      return monthsInRange;
    },
    formateTotalQuantity() {
      this.totalQuantity = this.totalQuantity.toString().replace('.', '');
      this.totalQuantity = this.totalQuantity
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    async getLogs(id) {
      const loadID = id;

      try {
        const response = await getLogs(id);
        if (response.status == 200) {
          const json = await response.data;

          this.logs[loadID] = json;
        }
      } catch (e) {
        this.isLoading = false;
      }
    },
    putLogs(log) {
      var url = process.env.VUE_APP_DATA_API;
      url += '/logs';

      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      var payload = {
        item: log,
      };

      return fetch(url, {
        headers: myHeaders,
        body: JSON.stringify(payload),
        method: 'PUT',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then(() => {
          return true;
        })
        .catch((e) => {
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else {
            this.isLoading = false;
          }
        });
    },
    setCalcEdit(operand, unit, operation, checkPeriods = true) {
      var edit = {
        operand: operand,
        unit: unit,
        operation: operation,
        settings: [],
      };

      // Get settings for relevant operations
      if (checkPeriods) {
        // Add dates if any of both is !=
        const startDate = getCETTimeStampFromDate(
          this.operationParams.intervals.startDate
        );
        const endDate = getCETTimeStampFromDate(
          this.operationParams.intervals.endDate
        );
        if (
          startDate != this.timeseries.start ||
          endDate != this.timeseries.end
        ) {
          edit.settings.push(
            { key: 'start-date', value: startDate },
            { key: 'end-date', value: endDate }
          );
        }

        // Scale does not apply for times, days months or quarters
        // Add start-time
        if (this.startTime != '00:00')
          edit.settings.push({ key: 'start-time', value: this.startTime });

        // Add end-time
        if (this.endTime != '23:45')
          edit.settings.push({ key: 'end-time', value: this.endTime });

        // Add days
        if (this.selectedDays.length != 0) {
          edit.settings.push({
            key: 'days',
            value: this.selectedDays.map((e) => e.text),
          });
        }

        // Add months
        if (this.selectedMonths.length != 0) {
          edit.settings.push({
            key: 'months',
            value: this.selectedMonths.map((e) => e.text),
          });
        }

        // Add quarters
        if (this.selectedQuarters.length != 0) {
          edit.settings.push({
            key: 'quarters',
            value: this.selectedQuarters.map((e) => e.text),
          });
        }
      }

      // Reset logs, when user switches back and creates new TS
      if (!this.isLastLoad) {
        this.calcEdits.length = this.selectedSeriesIndex;
      }

      // Add to edits
      this.$set(this.calcEdits, this.calcEdits.length, edit);
    },
    checkMetaDataChange(key) {
      // Get latest saved loadprofile
      const ts =
        this.lastSavedLoad != null ? this.lastSavedLoad : this.loadProfile;

      // Compare if value changed, log change
      if (key != 'unit') {
        var newValue;
        var oldValue;
        if (key == 'maLoID') {
          newValue = this.timeseries.supplyPoint.maLoID;
          oldValue =
            typeof ts.supplyPoint == 'string' ? '' : ts.supplyPoint.maLoID;
        } else {
          newValue = this.timeseries[key];
          oldValue = ts[key];
        }

        if (newValue != oldValue) {
          this.saveSeriesWithChanges(false);
          this.setMetaEdit(key, oldValue, newValue);
        }
      }
    },
    handleUnitLog(newQuantity, oldQuantity) {
      const factor = newQuantity / oldQuantity;
      if (factor != 0) this.setCalcEdit(newQuantity, null, 'scale', false);
    },
    setMetaEdit(key, oldVal, newVal, addToNewLoad = false) {
      var edit = {
        key: key,
        'old-value': oldVal,
        'new-value': newVal,
      };

      // Add to edits
      this.$set(this.metaEdits, this.metaEdits.length, edit);

      if (!addToNewLoad) this.saveMetaLogs();
    },
    saveMetaLogs() {
      this.setAndCreateLogObject(
        this.timeseries.id,
        'timeseries-metadata-update',
        JSON.parse(JSON.stringify(this.metaEdits))
      );
      // reset edits
      this.metaEdits = [];
    },
    saveCalcLogs(id) {
      const edits = JSON.parse(JSON.stringify(this.calcEdits));
      for (let edit of edits) {
        this.setAndCreateLogObject(id, 'timeseries-calculation', [edit]);
      }
      // reset edits
      this.calcEdits = [];
    },
    dismissAlert(id) {
      this.periodAlerts.find((e) => e.id == id).display = false;
    },
    getPlotBandStructureWithValue(
      startTime,
      endTime
      // colorofBand,
      // bandId,
      // bandName
    ) {
      return {
        from: startTime,
        to: endTime,
        // color: colorofBand,
        // id: bandId,
        // label: {
        //   text: bandName,
        //   style: {
        //     color: '#606060',
        //   },
        // },
      };
    },
    filterXAxisPlotBands(filterName) {
      this.xAxisPlotBands = this.xAxisPlotBands.filter(
        (plotBand) => plotBand.id != filterName
      );
    },
    getImgUrl(img) {
      const images = require.context('../assets/img/', false, /\.svg$/);
      return images(img);
    },
    updateChartWithDragPoints() {
      if (this.$refs.Chart.chart.series[0].closestPointRangePx > 6) {
        this.$refs.Chart.addDraggingToChart();
      } else {
        this.$refs.Chart.removeDraggingToChart();
      }
    },
    toggleOperationOverlay(dragValue) {
      this.isOperationOverlayVisible = dragValue;
    },
    getFormatedDate(date) {
      if (date) return timestampToCETConvertor(date).slice(0, 16);
    },
    toggleChart() {
      this.typeOfLoadedChart == 'highChart'
        ? (this.typeOfLoadedChart = 'stockChart')
        : (this.typeOfLoadedChart = 'highChart');
    },
    setAndCreateLogObject(timeSeriesId, activityType, activityToEdit) {
      // Create unique time for each
      const time = new Date().getTime();
      // Define log
      const dataLog = {
        author: this.user.attributes.sub,
        'time-start': time,
        'time-end': time,
        'context-parent-type': 'database',
        'context-parent-id': this.database.name,
        'context-type': 'database-item',
        'context-id': timeSeriesId,
        'activity-values': {
          'activity-type': activityType,
          edits: activityToEdit,
        },
      };
      // Append to results
      if (!this.logs.hasOwnProperty(timeSeriesId))
        this.$set(this.logs, timeSeriesId, []);

      this.$set(
        this.logs[timeSeriesId],
        this.logs[timeSeriesId].length,
        dataLog
      );

      // save logs
      this.putLogs(dataLog);
      return dataLog;
    },
    handleDragDataPointsChange(newValues) {
      this.dragPointEdits = [...this.dragPointEdits, ...newValues];
    },
    saveDragDataPointLogs(id) {
      this.setAndCreateLogObject(id, 'timeseries-data-update', [
        { changes: this.dragPointEdits },
      ]);
      // reset edits
      this.dragPointEdits = [];
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    onUnitChange(unit) {
      this.activeUnit = unit;
      this.addUnitWithoutConvert();
    },
    onBlocksChange(blocks) {
      this.operationParams.blocks = blocks;
    },
    getFormatedDateInCET(timestamp) {
      return timestampToCETConvertor(timestamp, 'Do MMM YYYY HH:mm:ss');
    },
    onInputChangeOfOperationValue() {
      this.operationParams.value =
        this.operationParams.value.match(/^\d+\.?\d{0,10}/);
    },
    async runAction(action) {
      try {
        this.isRunActionLoadingModalVisible = true;
        const id = action.id;
        const flowVersion = action.version || 2;
        const flowExecutionURL = action.executionUrl
          ? action.executionUrl
          : null;
        const params = `?id=${id}&modeldatabaseid=${this.database.name}&model=${this.loadProfile.id}`;
        if (flowVersion < 3) {
          const response = await runFlowByID(flowExecutionURL, params);

          if (response && response.status === 200 && response.data) {
            this.isRunActionLoadingModalVisible = false;
            this.$set(this.htmlViewerModal, 'myHtml', response.data);
            this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', true);
          }
        } else {
          this.isRunActionLoadingModalVisible = false;
          this.vueBasedProcessPreview.isVisible = true;
          this.vueBasedProcessPreview.params = params;
          this.vueBasedProcessPreview.flowId = id;
          this.vueBasedProcessPreview.executionUrl = action.executionUrl;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({ error });
        this.isRunActionLoadingModalVisible = false;
      }
    },
    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);
    },
    newID() {
      return getFlowLastId(this);
    },
    async createNewAction() {
      let id = this.newID();
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: id,
        type: 'action',
        dataType: 'loadprofile',
        fileKey: this.loadProfile.id,
        tableID: this.database.name,
        version: newWorkflowDefaultVersion, //  default action workflow version
      });

      if (rslt == 'Access Token has expired') {
        this.handleExpiredAuth();
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'process-designer',
            process: id,
          },
        });
      }
    },
    isTableIdArray(tableID) {
      if (typeof tableID === 'string') {
        return false;
      }

      if (Array.isArray(tableID)) {
        return true;
      }

      return null;
    },

    onCloseVueBasedPreview() {
      this.vueBasedProcessPreview = {
        isVisible: false,
        params: '',
        flowId: null,
      };
    },
    onCloseRunActionLoadingModal() {
      this.isRunActionLoadingModalVisible = false;
    },
  },
  created() {
    this.fetchData();

    // Set default start/end for operation Params
    this.resetDateInterval(true);

    // Get months from timeseries
    const months = this.getMonthsFromRange(
      this.timeseries.start,
      this.timeseries.end
    );
    this.monthsInterval = months;

    this.quarters = this.listQuarters(
      convertDateToCETDate(this.timeseries.start),
      convertDateToCETDate(this.timeseries.end)
    );

    // Set default values to userSettings if given
    this.setUserSettings();

    // Add class to make background fixed
    document.body.classList.add('modal-open');

    setTimeout(() => {
      this.isRendered = true;
    }, 1000);
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  mounted() {
    this.formatExcelData = true;
  },
  watch: {
    loadProfile: {
      handler(load) {
        //TODO: Use updated / created with the next refactoring
        if (this.seriesList[0].quantity.unit != load.quantity.unit) {
          this.seriesList.splice(0, 1, load);
          this.loading = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      getAllFlows: 'getAllFlows',
      userHasPermissionToAddFlow: 'getUserPermissionToAddFlow',
    }),
    activeFrequencies() {
      return this.frequencyList.filter((e) => e.value != 'D');
    },
    getPlotBands() {
      return this.xAxisPlotBands;
    },
    user() {
      return store.state.user;
    },
    loadProfileDetails() {
      return store.state.appSettings.loadProfileDetails;
    },
    timeseries() {
      return this.seriesList[this.selectedSeriesIndex];
    },
    isLastLoad() {
      return this.selectedSeriesIndex + 1 == this.seriesList.length;
    },
    isFirstLoad() {
      return this.selectedSeriesIndex === 0;
    },
    isSaveSeriesDisabled() {
      return (
        this.isOperationOverlayVisible ||
        this.isFirstLoad ||
        this.timeseries.isSaved
      );
    },
    selectedDays() {
      return this.days.filter((e) => e.selected);
    },
    selectedMonths() {
      return this.monthsInterval.filter((e) => e.selected);
    },
    selectedQuarters() {
      return this.quarters.filter((e) => e.selected);
    },
    startTime() {
      let startH = this.operationParams.intervals.startTime.HH;
      let startM = this.operationParams.intervals.startTime.mm;
      return startH + ':' + startM;
    },
    endTime() {
      let endH = this.operationParams.intervals.endTime.HH;
      let endM = this.operationParams.intervals.endTime.mm;
      return endH + ':' + endM;
    },
    isAnyCriteraSelected() {
      if (this.isDateCriteriaSelected) return true;
      else if (this.isTimeCriteriaSelected) return true;
      else if (this.selectedDays.length > 0) return true;
      else if (this.selectedMonths.length > 0) return true;
      else if (this.selectedQuarters.length > 0) return true;
      else return false;
    },
    isDateCriteriaSelected() {
      var isDateRangeChanged = false;
      const start = timestampToCETConvertor(this.timeseries.start);
      const end = timestampToCETConvertor(this.timeseries.end);

      // Compare, if date is changed
      if (this.operationParams.intervals.startDate != start)
        isDateRangeChanged = true;
      if (this.operationParams.intervals.endDate != end)
        isDateRangeChanged = true;

      return isDateRangeChanged;
    },
    isTimeCriteriaSelected() {
      var isTimeIntervalChanged = false;
      const start = { HH: '00', mm: '00' };
      const end = { HH: '23', mm: '45' };

      // Compare, if time is changed
      if (this.operationParams.intervals.startTime.HH != start.HH)
        isTimeIntervalChanged = true;
      if (this.operationParams.intervals.startTime.mm != start.mm)
        isTimeIntervalChanged = true;
      if (this.operationParams.intervals.endTime.HH != end.HH)
        isTimeIntervalChanged = true;
      if (this.operationParams.intervals.endTime.mm != end.mm)
        isTimeIntervalChanged = true;

      return isTimeIntervalChanged;
    },
    isSrcLoadSelected() {
      return this.selectedSeriesIndex == 0;
    },
    selectedMetaData() {
      return this.selectionMetaData.find((e) => e.id == this.timeseries.id);
    },
    isChartSelectionActive() {
      return this.selectionStartTS != null && this.selectionEndTS != null;
    },
    userSettings() {
      return store.state.userSettings;
    },
    activeUnit: {
      get() {
        if (this.selectedUnit) return this.selectedUnit;
        else return this.timeseries.unit;
      },
      set(unit) {
        this.selectedUnit = unit;
      },
    },
    activeFrequency: {
      get() {
        let frequencyValue;
        if (this.selectedFrequency) frequencyValue = this.selectedFrequency;
        else frequencyValue = this.timeseries.freq;
        return this.frequencyList.find(
          (frequency) => frequency.value == frequencyValue
        ).label;
      },
      set(unitFrequency) {
        this.selectedFrequency = unitFrequency;
      },
    },
    totalQuantity: {
      get() {
        if (this.operationParams.totalQuantity != null)
          return this.operationParams.totalQuantity;
        else if (this.selectedMetaData != null)
          return this.selectedMetaData.quantity.value;
        else return this.timeseries.quantity.value;
      },
      set(quantity) {
        this.operationParams.totalQuantity = quantity;
      },
    },
    activeUpdates() {
      if (this.logs.hasOwnProperty(this.timeseries.id))
        return this.logs[this.timeseries.id];
      else return [];
    },
    isMetaDataEditable() {
      const hasAccess = this.accessLevel != 'read';
      const isSaved = this.timeseries.isSaved == true;
      return hasAccess && (isSaved || this.isFirstLoad);
    },
    canEditTags() {
      return (
        this.isMetaDataEditable && !this.isAddOnly && !this.database?.add_only
      );
    },
    timeseriesTagObjects() {
      return this.parseTimeseriesTagsToObjects(this.timeseries?.tags);
    },
    databaseTagSuggestions() {
      return this.parseDatabaseTags(this.database?.tags)
        .map((tag) => ({
          id: tag?.id || null,
          name: tag?.n || tag?.name || '',
          color: tag?.c || tag?.color || '#4f46e5',
        }))
        .filter((tag) => typeof tag.name === 'string' && tag.name.trim());
    },
    showDescription() {
      const ts = this.timeseries;
      const d = 'description';
      return ts.hasOwnProperty(d) && ts[d] != '' && ts[d] != null;
    },
    activePeriodAlerts() {
      return this.periodAlerts.filter((e) => e.display == true).splice(0, 3);
    },
    relevantQuarters() {
      // eslint-disable-next-line no-unused-vars
      const start = this.timeseries.start;
      // eslint-disable-next-line no-unused-vars
      const end = this.timeseries.end;
      //  this.quarters.filter(
      //   (e) => e.periodStart < end && e.periodEnd > start
      // );
      return this.quarters;
    },
    isFreqEditable() {
      return this.timeseries.freq != 'D' && this.isMetaDataEditable;
    },
    isSetSelectionDateRange() {
      return (
        !moment(this.operationParams.intervals.startDate).isSame(
          timestampToCETConvertor(this.timeseries.start)
        ) ||
        !moment(this.operationParams.intervals.endDate).isSame(
          timestampToCETConvertor(this.timeseries.end)
        )
      );
    },
    isAdmin() {
      return store.state.isAdmin;
    },

    actionList() {
      return this.getAllFlows.filter((element) => {
        if (
          element.type === 'action' &&
          (element.dataType === 'timeseries' ||
            element.dataType === 'loadprofile')
        ) {
          if (
            !element.table_id ||
            (Array.isArray(element.table_id) && !element.table_id.length)
          ) {
            return true; // Filter if table_id is null or not exists
          } else if (Array.isArray(element.table_id)) {
            return element.table_id.includes(this.database.name.trim());
          } else if (typeof element.table_id === 'string') {
            return element.table_id === this.database.name.trim();
          } else return false;
        }
        return false;
      });
    },
    isLoadProfileTypeCustom() {
      return String(this.timeseries?.ts_type || '')
        .toLowerCase()
        .includes('loadcurvecustom');
    },
  },
  components: {
    ModalShare,
    VueTimepicker,
    changeUnitModal,
    LoadingSpinner,
    Updates,
    StockChart,
    GeneralDropdown,
    htmlViewer,
    GeneralModal,
    ProcessPreview,
    LoadProfileTagManagerModal,
  },
};
</script>

<style scoped>
.chart {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  background: #fff;
  -webkit-box-shadow: 0 0 20px rgba(31, 37, 50, 0.2);
  box-shadow: 0 0 20px rgba(31, 37, 50, 0.2);
  border: 1px solid #d6d6dd;
  image-rendering: optimizeQuality;
  padding: 35px 35px 35px 15px;
}

#boardChart {
  -webkit-font-smoothing: antialiased;
  position: fixed;
  width: 100%;
  height: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1003;
  text-align: left;
  background: #fff;
  color: #41495a;
}

.label {
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 31px;
  font-size: 14px;
}

.value {
  margin-bottom: 8px;
}

.big-font {
  font-size: 28px;
}

.small {
  color: #8c96a9;
  font-weight: 200;
}

.clickable {
  cursor: pointer;
  color: #8c96a9;
  font-weight: 200;
  font-size: 14px;
}

.clickable.grey {
  color: #a4a4a4;
}

.clickable.grey:hover {
  color: #bfbebe;
}

.clickable.grey.active {
  color: #fff;
}

.half {
  display: inline-block;
  width: 40%;
}

.value.small {
  color: #687082;
  font-size: 13px;
  font-weight: 200;
}

.value.small input {
  padding: 0;
}
.value.small select {
  border: none;
  outline: none;
  background: white;
}
.value.small select[disabled] {
  /* display: none; */
  /* for Firefox */
  -moz-appearance: none;
  appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}

.info-item {
  margin: 0;
}

.chart-content {
  box-sizing: border-box;
  text-align: center;
  margin-top: 0;
  -webkit-transition: padding 0.3s;
  -o-transition: padding 0.3s;
  transition: padding 0.3s;
  position: absolute;
  padding: 30px 497px 100px 38px;
  -webkit-box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.chart-switch {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 19;
  padding-right: 497px;
}

.chart-switch i {
  font-size: 50px;
  padding: 0 25px 0 25px;
  cursor: pointer;
}

.chart-wrap {
  top: 0;
  left: 0;
  -webkit-transition: padding 0.3s;
  -o-transition: padding 0.3s;
  transition: padding 0.3s;
  box-sizing: border-box;
  position: absolute;
  padding: 100px 497px 100px 38px;
  -webkit-box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: block;
}
.side-panel {
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  width: 439px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgba(20, 26, 40, 0.08);
  overflow-y: scroll;
}
.side-panel-inner {
  text-align: left;
  margin-top: 100px;
}
.side-bar-options.wrapper {
  position: fixed;
  top: 0;
  padding-top: 25px;
  width: inherit;
  background: white;
  text-align: right;
}

.side-bar-options {
  padding-right: 25px;
}

.side-bar-options ul {
  display: block;
  list-style-type: none;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.side-bar-options > li {
  display: inline-block;
  margin-left: 10px;
}

.side-bar-options {
  z-index: 20;
}

.side-bar-options > li.download .download-excel:hover {
  background: rgba(0, 0, 0, 0.03);
  background-image: url('../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  background-position: -1212px -425px;
  transition: color 0.15s;
  cursor: pointer;
}

.side-bar-options > li.download .download-excel {
  box-sizing: border-box;
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  top: 11px;
  left: 11px;
  background: #fff;
  background-image: url('../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  background-position: -1212px -425px;
  transition: color 0.15s;
}

.side-bar-options > li.more .more-button:hover {
  background: rgba(0, 0, 0, 0.03);
  background-image: url('../assets/img/list icon.svg');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  background-position: -1212px -425px;
  transition: color 0.15s;
  cursor: pointer;
}

.side-bar-options > li.more .more-button {
  box-sizing: border-box;
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  top: 11px;
  left: 11px;
  background: #fff;
  background-image: url('../assets/img/list icon.svg');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  background-position: -1212px -425px;
  transition: color 0.15s;
}
.side-bar-options > li > a:hover {
  background: rgba(0, 0, 0, 0.03);
  background-image: url('../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  transition: color 0.15s;
  cursor: pointer;
}

.side-bar-options > li > a {
  box-sizing: border-box;
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  top: 11px;
  left: 11px;
  background: #fff;
  background-image: url('../assets/img/boards-sprite.png');
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  background-size: 1236px 1221px;
  transition: color 0.15s;
}

.side-bar-options > li.share > a {
  background-position: -1212px -178px;
}

.side-bar-options > li.sidebar-toggle > a {
  background-position: -219px -1197px;
}

.side-bar-options > li.close-modal > a {
  background-position: -442px -1131px;
}

.accessibility {
  z-index: 30;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 0px !important;
}

.load-details {
  margin: 10%;
  max-width: 80%;
  display: block;
  text-align: left;
  padding: 0px;
}

input:disabled {
  background: white;
}

.load-details .rename.title {
  width: 100%;
  color: #1f2532;
  width: 100%;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
  margin-bottom: 15px;
  padding: 0;
  outline: none;
}

.load-details .rename.subtitle {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  color: #1f2532;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.125px;
  padding: 0 0 3px;
  margin-top: 7px;
  margin-bottom: 7px;
  top: 0;
  left: 0;
  height: 20px;
  width: 100%;
}

.load-details > input.rename::placeholder {
  content: attr(data-placeholder);
  color: #a0a4ad;
  font-style: inherit;
  display: block;
}

.load-details > input.rename:focus {
  outline: medium none;
}

.load-details .analysis-title {
  font-size: 11px;
  color: rgb(53 71 87);
  letter-spacing: 0.03em;
  max-width: 220px;
  overflow: hidden;
  font-family: 'Open Sans', open-sans, sans-serif;
  line-height: 23px;
}

.load-details .load-statistics {
  font-family: 'Open Sans', open-sans, sans-serif;
  color: #22303c;
  font-size: 14px;
  margin-top: 40px;
}

.vertical-btns {
  margin-left: 15px;
  width: 100px;
  display: inline-block;
}

.vertical-btns > button {
  font-size: 27px;
  background: none;
  border-style: none;
  margin-left: 5px;
}

.row {
  margin: 0px;
  padding-top: 10px;
}

.side-bar-options .button--loading::after {
  content: '';
  position: absolute;
  width: 34px;
  height: 34px;
  right: 138px;
  bottom: 27px;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: #181818;
  border-radius: 50%;
  animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}

.operations label {
  margin-top: 10px;
  margin-bottom: 0;
  color: #a4a4a4;
}
.operation-methods .row {
  margin-bottom: 15px;
}
.operations a {
  text-decoration: underline;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
}
.load-profile-details .operation-method.btn {
  width: 35px;
  height: 35px;
  border-radius: 10px;
  margin: 4px 0;
  padding: 0;
  border: solid 1px #9da0a8;
  background: #22303c;
  color: white;
  padding: 0;
  line-height: 32px;
}

.load-profile-details .operation-methods.calculation-btn {
  justify-content: end;
}

.load-profile-details .operation-method.calculation-left-btn {
  margin-right: 8px;
}

.load-profile-details .more-operations .duration-button-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px;
}
.operation-method.btn:hover {
  border: solid 1px #ffff;
}
.operation-method.grey-out.btn:hover {
  border: solid 1px #9da0a8;
}
.operation-method.grey-out.btn {
  color: #727274;
  border-color: #727274 !important;
  cursor: not-allowed;
}

input[type='datetime-local'] {
  position: relative;
}
input[type='datetime-local']::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 10px;
  cursor: pointer;
  opacity: 0.8;
  filter: invert(1);
}

.operations {
  background: #22303c;
  color: white;
  border-radius: 5px;
  padding: 15px 0px;
  display: block;
  transition: transform 0.2s ease-in, opacity 0.2s ease,
    -webkit-transform 0.2s ease-in;
  transition: transform 0.2s ease-in, height 0.2s ease,
    -webkit-transform 0.2s ease-in;
  animation: fadeIn 1s;
  overflow: hidden;
}

.operations input {
  border: solid 1px #9da0a8;
  border-radius: 3px;
  background: #22303c;
  color: white;
  width: 100%;
  box-sizing: border-box;
  padding-left: 12px;
  padding-top: 3px;
}

.operations input[type='checkbox'] {
  width: 12px;
  margin: 0;
  margin-right: 10px;
}

@keyframes fadeIn {
  0% {
    margin-top: 50px;
    opacity: 0;
  }
  50% {
    margin-top: 0px;
    opacity: 1;
  }
  100% {
    margin-top: 0px;
    opacity: 1;
  }
}

.button {
  border-radius: 22px;
  padding: 8px 21px 8px 21px;
  float: left;
  margin: 0px 1px 0 19px;
  outline: 0;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.13px;
  color: #fff;
  border: solid 1px #9da0a8;
}

.button.save {
  width: 109px;
  height: 43px;
}

.button.save.saving {
  color: #9cf435;
  border: solid 1px #71b225;
}

.button.save.saving:hover i {
  border: none;
}

.button.save.disabled {
  opacity: 0.5;
}

.button:hover :not(.disabled) {
  border: solid 1px #ffff;
  transition: 200ms;
}

.button.save span {
  border-style: none;
}

.malo-id {
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 19px;
  line-height: 36px;
  font-weight: 600;
  color: #1f2532;
}

.load-profile-details .operation-method.day.btn {
  font-size: 12px;
  line-height: 34px;
  width: calc((100% / 7) - 8px);
  margin: 0 4px 8px;
}

.operation-method.day.btn.clicked {
  background-color: #ffff;
  border-color: #ffff;
  color: #22303c;
}

.btn.remove-value {
  margin-left: -2px;
  background-image: url('../assets/img/series_negative_val.svg');
  background-size: 25px 25px;
  background-position: 50%;
  background-repeat: no-repeat;
}

.custom-picker {
  margin-top: 15px;
}

/* Custom input */
::v-deep .vue__time-picker input.display-time {
  background: #13181c;
  color: white;
  outline: none;
  border: solid 1px #9da0a8;
  border-radius: 3px;
  background: #22303c;
  color: white;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 12px;
}

/* Dropdown open background */
::v-deep .dropdown.drop-down {
  background: #22303c;
  color: white;
}

/* Dropdown text (not selected) */
::v-deep .dropdown.drop-down .select-list li {
  color: #9da0a8;
}
/* Dropdown selected item background */
::v-deep .vue__time-picker .dropdown ul li:not([disabled]).active {
  background: #ffff;
  color: #22303c;
}

/* Dropdown item text on hover */
::v-deep .vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover {
  color: white;
}

::v-deep .vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #ffff;
  color: #9da0a8;
}

/* D'ont color border if minutes are not in 15 min steps*/
::v-deep .vue__time-picker input.display-time.invalid:not(.skip-error-style) {
  border-color: #9da0a8;
  outline-color: none;
}
.unit-wrap {
  cursor: pointer;
}
.form-modal {
  position: relative;
}

.units {
  position: absolute;
  top: 8px;
  right: 22px;
  font-size: 10px;
}

.operation-method.btn.selected {
  background: #fff;
  color: #22303c;
}
.operation-method.btn.selected i {
  color: #22303c;
}
.edit-icon {
  margin: 0 0 0 5px !important;
  display: inline-flex !important;
  min-width: unset !important;
  max-width: unset !important;
  padding: 0 !important;
  width: 20px;
  height: 20px;
  align-items: center;
  line-height: 0;
  cursor: pointer;
  position: relative;
}
.edit-icon:after {
  background-image: url(/img/project-sprite.1c2e7465.png);
  background-size: 882px 840px;
  background-position: -728px -691px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
  top: 10px;
  left: 0;
  position: absolute;
  content: '';
  margin: 0;
}

.side-bar-options.wrapper.modal-open {
  z-index: 0;
}

.operation-method.btn i {
  font-size: 12px;
}
.operation-method.btn i {
  color: #eeeff3;

  font-size: 11px;
}

.operation-method.btn.grey-out i {
  color: #727274;
}

input[type='number'] {
  outline: none;
}
.formatted-number {
  outline: none;
}

.set-quantity {
  display: flex;
  align-items: center;
  border: 1px solid #9da0a8;
  width: 100%;
  position: relative;
  margin-top: 10px;
  border-right: 0;
  box-sizing: border-box;
}

.set-quantity input {
  border: none !important;
}

.set-quantity button {
  background: transparent;
  color: #fff;
  box-shadow: none;
  border-top: none !important;
  border-bottom: none !important;
  left: 100%;
  border: 1px solid #9da0a8;
  height: 30px;
  z-index: 1;
  transition: all 400ms ease-in-out;
  font-size: 12px;
  padding: 1px 10px;
}
.set-quantity button:hover {
  background: #fff;
  color: #333;
}
.set-quantity .units {
  right: 39%;
}

.set-quantity.refresh {
  background: rgb(221 221 221);
  pointer-events: none;
}
.set-quantity.refresh .formatted-number {
  background: rgb(221 221 221);
}

.load-profile-details .operation-method.month.btn {
  line-height: normal;

  width: calc((100% / 4) - 8px);

  height: auto;
  padding: 10px 0;
  font-size: 12px;
  margin: 0 4px 8px;
}
.load-profile-details .operation-method.quarter.btn {
  font-size: 12px;

  width: calc((100% / 5) - 8px);
  margin: 0 4px 8px;
}
.load-profile-details .operation-method.sync.btn {
  line-height: normal;
  width: 140px;
  height: auto;
  padding: 10px 0;
  font-size: 12px;
  width: calc((100% / 2) - 8px);
  margin: 0 4px 8px;
}
.operation-method.sync.btn img {
  width: 45%;
}

/* loading-spinner in chart*/
::v-deep .chart-content .loading {
  z-index: 1;
  background: #ffffff9c;
}

/* loading-spinner in quantity input*/
::v-deep .set-quantity .loading .progress-icon-wrapper {
  top: 26px;
  left: -135%;
}
::v-deep .set-quantity .loading .progress-icon-wrapper .progress-icon::after {
  height: 20px;
  width: 20px;
}
.info-item.desription {
  box-sizing: border-box;
  display: block;
  align-items: center;
}

.info-item.desription .value.small {
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.info-item.desription span {
  flex: 1;
}

.info-item.desription .value.small textarea {
  outline: none;
  font-size: 13px;
  /* border: none; */
  margin: auto;
  background-color: #fff;
  resize: none;
  flex: 2.7;
  min-height: 13px;
  max-height: 146px;
  color: #687082;
  padding: 0;
}

.info-item.desription .value.small textarea[disabled] {
  border: 0;
  padding: 0;
}

.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .info-item.desription
  .value.small
  .text-area-div {
  /* border: none; */
  /* flex: 2.7; */
  outline: none;
  font-size: 13px;
  margin: auto;
  background-color: #fff;
  resize: none;
  min-height: 13px;
  max-height: 146px;
  color: #687082;
  padding: 0;
  width: 100%;
  overflow: auto;
}
.clock-icon {
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  display: block;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -12px;
  box-sizing: border-box;
  font-size: 14px;
  cursor: pointer;
}

.more-icon {
  border: 1px solid #dbdde0;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  display: block;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -12px;
  box-sizing: border-box;
  font-size: 14px;
  cursor: pointer;
}

.calculation-selection.sub-title {
  color: #a4a4a4;
}
label .selection-label {
  margin-left: 2px;
}

.load-details .tags .badge-secondary {
  padding: 5px;
  margin-right: 5px;
  margin-bottom: 6px;
}

.load-details .tags-section {
  margin-top: 8px;
}

.load-details .tags .tag-preview-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.load-details .tags .tag-label {
  line-height: 1;
}

.load-details .tags-empty {
  color: #4b4b4b;
  font-size: 12px;
}

.tag-manager-trigger {
  position: relative;
}

.tag-manager-trigger .tag-counter {
  position: absolute;
  top: -8px;
  right: -5px;
  min-width: 17px;
  height: 17px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

#boardChart .warning-area {
  float: right;
  min-width: 30%;
  width: fit-content;
  z-index: 25;
  position: relative;
}

#boardChart .alert {
  margin-bottom: 1px;
  padding-right: 0;
}

.alert .alert-message {
  padding-left: 10px;
  padding-right: 10px;
}

.alert .alert-close {
  float: right;
  padding-right: 15px;
}

.chart-operation-block-overlay {
  opacity: 0.5;
  pointer-events: not-allowed;
  position: relative;
}

.chart-operation-block-overlay:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgb(34 48 60 / 50%);
  pointer-events: not-allowed;
}
.info-row-items {
  padding-left: 0;
  padding-right: 1.5rem;
}
.change-chart-icon {
  position: absolute;
  z-index: 9;
  right: 0;
  opacity: 0;
  top: 0;
  margin: 5px 5px 0 0;
  cursor: pointer;
}
.change-chart-icon:hover {
  opacity: 1;
}

.operation-methods.col {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  max-width: 132px;
  flex: 35% 0 0;
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
}

.operations .checkbox-label label {
  margin-top: 0;
}
::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .operations
  .chart-date-input-range {
  display: block;
}

span.tool-icon.more-icon img {
  width: 17px;
}
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .value.small
  span.title-tag {
  min-width: 70px;
  display: inline-block;
}
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .info-item
  .filter-dropdown
  .line-clamp {
  text-align: left;
  min-width: 90px;
  font-size: 12px;
}
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .line-clamp.frequency {
  min-width: 90px;
  text-align: left;
  font-size: 12px;
}
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .info-item.desription {
  cursor: text;
  min-height: 30px;
  position: relative;
  color: #687082;
}

/* .info-item.desription:before {
  content: 'Enter Text';
  position: absolute;
  top: 5px;
} */
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .info-item.desription[placeholder]:empty::before {
  content: attr(placeholder);
  color: #555;
}

.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .info-item.desription[placeholder]:empty:focus::before {
  content: '';
}
.load-profile-details
  .side-panel
  .side-panel-inner
  .load-statistics
  .info-item.desription
  .value.small {
  margin-bottom: 0;
}

[contenteditable='true']:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  display: block; /* For Firefox */
}

.run-action-loading-center {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
